/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.2.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import moment from 'moment';
import 'moment-duration-format';
import { store } from '@/store/store';
import { Vue } from 'vue-property-decorator';
import { app } from '@/main';
export class ClientBase {
  private firstRun = true;
  constructor() {}

  protected transformOptions(options: any) {
    this.setUpInterceptors();
    const token = this.getToken();
    if (token) {
      options.headers['Authorization'] = 'bearer ' + token;
    }
    const language = store.getLanguageCode;
    if (language) {
      options.headers['Accept-Language'] = language;
    }
    return Promise.resolve(options);
  }
  private getToken(): string | undefined {
    return store.token;
  }
  private setUpInterceptors(): void {
    if (!this.firstRun) {
      return;
    }
    const instance = (this as any).instance as AxiosInstance;
    instance.interceptors.request.use(config => {
      app.$Progress.start();
      return config;
    });
    instance.interceptors.response.use(
      response => {
        app.$Progress.finish();
        return response;
      },
      error => {
        app.$Progress.finish();
        throw error;
      }
    );

    this.firstRun = false;
  }
}

export class DiscountAdminClient extends ClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getDiscountList(  cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<DiscountAdminDto[]>> {
        let url_ = this.baseUrl + "/GetDiscountList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiscountList(_response);
        });
    }

    protected processGetDiscountList(response: AxiosResponse): Promise<SwaggerResponse<DiscountAdminDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscountAdminDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<DiscountAdminDto[]>>(new SwaggerResponse<DiscountAdminDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<DiscountAdminDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateDiscount(inputModel: DiscountAdminUpdateInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<DiscountAdminDto>> {
        let url_ = this.baseUrl + "/UpdateDiscount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDiscount(_response);
        });
    }

    protected processUpdateDiscount(response: AxiosResponse): Promise<SwaggerResponse<DiscountAdminDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiscountAdminDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<DiscountAdminDto>>(new SwaggerResponse<DiscountAdminDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<DiscountAdminDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getDiscount(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<DiscountAdminDto>> {
        let url_ = this.baseUrl + "/GetDiscount?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiscount(_response);
        });
    }

    protected processGetDiscount(response: AxiosResponse): Promise<SwaggerResponse<DiscountAdminDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiscountAdminDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<DiscountAdminDto>>(new SwaggerResponse<DiscountAdminDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<DiscountAdminDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getPaymentOrdersList(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<OrderListItemAdminDataDto[]>> {
        let url_ = this.baseUrl + "/GetPaymentOrdersList?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentOrdersList(_response);
        });
    }

    protected processGetPaymentOrdersList(response: AxiosResponse): Promise<SwaggerResponse<OrderListItemAdminDataDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderListItemAdminDataDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<OrderListItemAdminDataDto[]>>(new SwaggerResponse<OrderListItemAdminDataDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<OrderListItemAdminDataDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    addDiscount(id: string | undefined, email: string | null | undefined, code: string | null | undefined, discount: number | undefined, isActive: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<DiscountAdminDto>> {
        let url_ = this.baseUrl + "/AddDiscount?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (discount === null)
            throw new Error("The parameter 'discount' cannot be null.");
        else if (discount !== undefined)
            url_ += "Discount=" + encodeURIComponent("" + discount) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDiscount(_response);
        });
    }

    protected processAddDiscount(response: AxiosResponse): Promise<SwaggerResponse<DiscountAdminDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiscountAdminDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<DiscountAdminDto>>(new SwaggerResponse<DiscountAdminDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<DiscountAdminDto>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class GameClient extends ClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getGameTemplatesForCreateDropdown(  cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<GameTemplateDto[]>> {
        let url_ = this.baseUrl + "/Game/GetGameTemplatesForCreateDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGameTemplatesForCreateDropdown(_response);
        });
    }

    protected processGetGameTemplatesForCreateDropdown(response: AxiosResponse): Promise<SwaggerResponse<GameTemplateDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GameTemplateDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<GameTemplateDto[]>>(new SwaggerResponse<GameTemplateDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<GameTemplateDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getGameInstancesByUser(  cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<GameInstanceDto[]>> {
        let url_ = this.baseUrl + "/Game/GetGameInstancesByUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGameInstancesByUser(_response);
        });
    }

    protected processGetGameInstancesByUser(response: AxiosResponse): Promise<SwaggerResponse<GameInstanceDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GameInstanceDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<GameInstanceDto[]>>(new SwaggerResponse<GameInstanceDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<GameInstanceDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getGameInstanceById(gameInstanceId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<GameInstanceDto>> {
        let url_ = this.baseUrl + "/Game/GetGameInstanceById?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGameInstanceById(_response);
        });
    }

    protected processGetGameInstanceById(response: AxiosResponse): Promise<SwaggerResponse<GameInstanceDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GameInstanceDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<GameInstanceDto>>(new SwaggerResponse<GameInstanceDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<GameInstanceDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    createGameInstance(inputModel: GameInstanceCreateInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<GameInstanceDto>> {
        let url_ = this.baseUrl + "/Game/CreateGameInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGameInstance(_response);
        });
    }

    protected processCreateGameInstance(response: AxiosResponse): Promise<SwaggerResponse<GameInstanceDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GameInstanceDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<GameInstanceDto>>(new SwaggerResponse<GameInstanceDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<GameInstanceDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateGameInstance(inputModel: GameInstanceUpdateInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<GameInstanceDto>> {
        let url_ = this.baseUrl + "/Game/UpdateGameInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGameInstance(_response);
        });
    }

    protected processUpdateGameInstance(response: AxiosResponse): Promise<SwaggerResponse<GameInstanceDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GameInstanceDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<GameInstanceDto>>(new SwaggerResponse<GameInstanceDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<GameInstanceDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    deleteGameInstance(inputModel: GameInstanceDeleteInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<GameInstanceDto>> {
        let url_ = this.baseUrl + "/Game/DeleteGameInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGameInstance(_response);
        });
    }

    protected processDeleteGameInstance(response: AxiosResponse): Promise<SwaggerResponse<GameInstanceDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GameInstanceDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<GameInstanceDto>>(new SwaggerResponse<GameInstanceDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<GameInstanceDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getAssignableProfessions(gameInstanceId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<AssignableProfessionDto[]>> {
        let url_ = this.baseUrl + "/Game/GetAssignableProfessions?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignableProfessions(_response);
        });
    }

    protected processGetAssignableProfessions(response: AxiosResponse): Promise<SwaggerResponse<AssignableProfessionDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignableProfessionDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<AssignableProfessionDto[]>>(new SwaggerResponse<AssignableProfessionDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<AssignableProfessionDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class GameInstanceAdminClient extends ClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getGameInstancesList(  cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<AdminGameInstanceListItemDto[]>> {
        let url_ = this.baseUrl + "/GetGameInstancesList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGameInstancesList(_response);
        });
    }

    protected processGetGameInstancesList(response: AxiosResponse): Promise<SwaggerResponse<AdminGameInstanceListItemDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminGameInstanceListItemDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<AdminGameInstanceListItemDto[]>>(new SwaggerResponse<AdminGameInstanceListItemDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<AdminGameInstanceListItemDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getGameInstance(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<AdminGameInstanceDto>> {
        let url_ = this.baseUrl + "/GetGameInstance?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGameInstance(_response);
        });
    }

    protected processGetGameInstance(response: AxiosResponse): Promise<SwaggerResponse<AdminGameInstanceDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdminGameInstanceDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<AdminGameInstanceDto>>(new SwaggerResponse<AdminGameInstanceDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<AdminGameInstanceDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getPaymentOrdersForGameInstance(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<OrderListItemAdminDataDto[]>> {
        let url_ = this.baseUrl + "/GetPaymentOrdersForGameInstance?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentOrdersForGameInstance(_response);
        });
    }

    protected processGetPaymentOrdersForGameInstance(response: AxiosResponse): Promise<SwaggerResponse<OrderListItemAdminDataDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderListItemAdminDataDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<OrderListItemAdminDataDto[]>>(new SwaggerResponse<OrderListItemAdminDataDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<OrderListItemAdminDataDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class GameRuntimeClient extends ClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getGameInstancePrivate(gameInstanceId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<RuntimeGameInstanceDto>> {
        let url_ = this.baseUrl + "/GameRuntime/GetGameInstancePrivate?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "gameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGameInstancePrivate(_response);
        });
    }

    protected processGetGameInstancePrivate(response: AxiosResponse): Promise<SwaggerResponse<RuntimeGameInstanceDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RuntimeGameInstanceDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<RuntimeGameInstanceDto>>(new SwaggerResponse<RuntimeGameInstanceDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<RuntimeGameInstanceDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getGameInstancePublic(gameInstanceId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<RuntimeGameInstanceDto>> {
        let url_ = this.baseUrl + "/GameRuntime/GetGameInstancePublic?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "gameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGameInstancePublic(_response);
        });
    }

    protected processGetGameInstancePublic(response: AxiosResponse): Promise<SwaggerResponse<RuntimeGameInstanceDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RuntimeGameInstanceDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<RuntimeGameInstanceDto>>(new SwaggerResponse<RuntimeGameInstanceDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<RuntimeGameInstanceDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    createPlayerInstance(inputModel: PlayerInstanceInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<PlayerInstanceDto>> {
        let url_ = this.baseUrl + "/GameRuntime/CreatePlayerInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePlayerInstance(_response);
        });
    }

    protected processCreatePlayerInstance(response: AxiosResponse): Promise<SwaggerResponse<PlayerInstanceDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlayerInstanceDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<PlayerInstanceDto>>(new SwaggerResponse<PlayerInstanceDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<PlayerInstanceDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getQuestionByProfession(professionId: string | undefined, playerInstanceId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/GameRuntime/GetQuestionByProfession?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "ProfessionId=" + encodeURIComponent("" + professionId) + "&";
        if (playerInstanceId === null)
            throw new Error("The parameter 'playerInstanceId' cannot be null.");
        else if (playerInstanceId !== undefined)
            url_ += "PlayerInstanceId=" + encodeURIComponent("" + playerInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionByProfession(_response);
        });
    }

    protected processGetQuestionByProfession(response: AxiosResponse): Promise<SwaggerResponse<string>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<SwaggerResponse<string>>(new SwaggerResponse<string>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, <any>null));
    }

    addPlayerInstanceAnswer(inputModel: PlayerInstanceAnswerInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<PlayerInstanceAnswerDto>> {
        let url_ = this.baseUrl + "/GameRuntime/AddPlayerInstanceAnswer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPlayerInstanceAnswer(_response);
        });
    }

    protected processAddPlayerInstanceAnswer(response: AxiosResponse): Promise<SwaggerResponse<PlayerInstanceAnswerDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlayerInstanceAnswerDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<PlayerInstanceAnswerDto>>(new SwaggerResponse<PlayerInstanceAnswerDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<PlayerInstanceAnswerDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    addPlayerInstanceLog(inputModel: PlayerInstanceLogInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<PlayerInstanceLogDto>> {
        let url_ = this.baseUrl + "/GameRuntime/AddPlayerInstanceLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPlayerInstanceLog(_response);
        });
    }

    protected processAddPlayerInstanceLog(response: AxiosResponse): Promise<SwaggerResponse<PlayerInstanceLogDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlayerInstanceLogDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<PlayerInstanceLogDto>>(new SwaggerResponse<PlayerInstanceLogDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<PlayerInstanceLogDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    addPlayerInstanceDetails(inputModel: PlayerInstanceDetailsInputModel, sendEmail: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<PlayerInstanceDto>> {
        let url_ = this.baseUrl + "/GameRuntime/AddPlayerInstanceDetails?";
        if (sendEmail === null)
            throw new Error("The parameter 'sendEmail' cannot be null.");
        else if (sendEmail !== undefined)
            url_ += "sendEmail=" + encodeURIComponent("" + sendEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPlayerInstanceDetails(_response);
        });
    }

    protected processAddPlayerInstanceDetails(response: AxiosResponse): Promise<SwaggerResponse<PlayerInstanceDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlayerInstanceDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<PlayerInstanceDto>>(new SwaggerResponse<PlayerInstanceDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<PlayerInstanceDto>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class LandingPageClient extends ClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    submitContactForm(inputModel: SubmitContactFormInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/LandingPage/SubmitContactForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitContactForm(_response);
        });
    }

    protected processSubmitContactForm(response: AxiosResponse): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse<void>(status, _headers, <any>null));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    submitEbookForm(inputModel: SubmitEmailFormInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/LandingPage/SubmitEbookForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitEbookForm(_response);
        });
    }

    protected processSubmitEbookForm(response: AxiosResponse): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse<void>(status, _headers, <any>null));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    downloadEbook(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/LandingPage/DownloadEbook?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadEbook(_response);
        });
    }

    protected processDownloadEbook(response: AxiosResponse): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, { fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers }));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class PaymentsAdminClient extends ClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getPaymentsList(  cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<PaymentsAdminDto[]>> {
        let url_ = this.baseUrl + "/GetPaymentsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentsList(_response);
        });
    }

    protected processGetPaymentsList(response: AxiosResponse): Promise<SwaggerResponse<PaymentsAdminDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentsAdminDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<PaymentsAdminDto[]>>(new SwaggerResponse<PaymentsAdminDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<PaymentsAdminDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getPayment(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<PaymentsAdminDto>> {
        let url_ = this.baseUrl + "/GetPayment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPayment(_response);
        });
    }

    protected processGetPayment(response: AxiosResponse): Promise<SwaggerResponse<PaymentsAdminDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentsAdminDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<PaymentsAdminDto>>(new SwaggerResponse<PaymentsAdminDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<PaymentsAdminDto>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class PaymentsClient extends ClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    pay(payInputModel: PayInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/Payments/Pay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payInputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPay(_response);
        });
    }

    protected processPay(response: AxiosResponse): Promise<SwaggerResponse<string>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<SwaggerResponse<string>>(new SwaggerResponse<string>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, <any>null));
    }

    showSummary(inputModel: GameInstanceRecipientDataInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/Payments/ShowSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShowSummary(_response);
        });
    }

    protected processShowSummary(response: AxiosResponse): Promise<SwaggerResponse<boolean>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Promise.resolve<SwaggerResponse<boolean>>(new SwaggerResponse<boolean>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, <any>null));
    }

    createEmptyPurchase(inputModel: CreateEmptyPurchaseInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<CreateEmptyPurchaseDto>> {
        let url_ = this.baseUrl + "/Payments/CreateEmptyPurchase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEmptyPurchase(_response);
        });
    }

    protected processCreateEmptyPurchase(response: AxiosResponse): Promise<SwaggerResponse<CreateEmptyPurchaseDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEmptyPurchaseDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<CreateEmptyPurchaseDto>>(new SwaggerResponse<CreateEmptyPurchaseDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<CreateEmptyPurchaseDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateOrder(updateNotification: PayUUpdateNotification , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/Payments/UpdateOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateNotification);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrder(_response);
        });
    }

    protected processUpdateOrder(response: AxiosResponse): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse<void>(status, _headers, <any>null));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    cancelPayment(orderNumber: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/Payments/CancelPayment?";
        if (orderNumber !== undefined && orderNumber !== null)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelPayment(_response);
        });
    }

    protected processCancelPayment(response: AxiosResponse): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse<void>(status, _headers, <any>null));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInitialOrderData(gameInstanceId: string | undefined, defaultCountryCode: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<GetInitialOrderDataDto>> {
        let url_ = this.baseUrl + "/Payments/GetInitialOrderData?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        if (defaultCountryCode !== undefined && defaultCountryCode !== null)
            url_ += "DefaultCountryCode=" + encodeURIComponent("" + defaultCountryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInitialOrderData(_response);
        });
    }

    protected processGetInitialOrderData(response: AxiosResponse): Promise<SwaggerResponse<GetInitialOrderDataDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInitialOrderDataDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<GetInitialOrderDataDto>>(new SwaggerResponse<GetInitialOrderDataDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<GetInitialOrderDataDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    verifyDiscount(code: string | null | undefined, currency: Currency | undefined, countryCode: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<VerifyDiscountResultDto>> {
        let url_ = this.baseUrl + "/Payments/VerifyDiscount?";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (currency === null)
            throw new Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "Currency=" + encodeURIComponent("" + currency) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyDiscount(_response);
        });
    }

    protected processVerifyDiscount(response: AxiosResponse): Promise<SwaggerResponse<VerifyDiscountResultDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerifyDiscountResultDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<VerifyDiscountResultDto>>(new SwaggerResponse<VerifyDiscountResultDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<VerifyDiscountResultDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getPriceInfo(netPrice: number | undefined, countryCode: string | null | undefined, discount: number | null | undefined, currency: Currency | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<GetPriceInfoDto>> {
        let url_ = this.baseUrl + "/Payments/GetPriceInfo?";
        if (netPrice === null)
            throw new Error("The parameter 'netPrice' cannot be null.");
        else if (netPrice !== undefined)
            url_ += "NetPrice=" + encodeURIComponent("" + netPrice) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (discount !== undefined && discount !== null)
            url_ += "Discount=" + encodeURIComponent("" + discount) + "&";
        if (currency === null)
            throw new Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "Currency=" + encodeURIComponent("" + currency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPriceInfo(_response);
        });
    }

    protected processGetPriceInfo(response: AxiosResponse): Promise<SwaggerResponse<GetPriceInfoDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPriceInfoDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<GetPriceInfoDto>>(new SwaggerResponse<GetPriceInfoDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<GetPriceInfoDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param vatNumber (optional) VAT Numbers, which trigger different responses.
    These codes works only when the payments are disabled (fake payments)
    
    100 = Valid request with Valid VAT Number
    200 = Valid request with an Invalid VAT Number
    201 = Error : INVALID_INPUT
    202 = Error : INVALID_REQUESTER_INFO
    300 = Error : SERVICE_UNAVAILABLE
    301 = Error : MS_UNAVAILABLE
    302 = Error : TIMEOUT
    400 = Error : VAT_BLOCKED
    401 = Error : IP_BLOCKED
    500 = Error : GLOBAL_MAX_CONCURRENT_REQ
    501 = Error : GLOBAL_MAX_CONCURRENT_REQ_TIME
    600 = Error : MS_MAX_CONCURRENT_REQ
    601 = Error : MS_MAX_CONCURRENT_REQ_TIME
    
    For all the other cases, The web service will responds with a "SERVICE_UNAVAILABLE" error.
     * @param countryCode (optional) Supported country codes
    
    AT = Austria
    BE = Belgium
    BG = Bulgaria
    CY = Cyprus
    CZ = Czech Republic
    DE = Germany
    DK = Denmark
    EE = Estonia
    EL = Greece
    ES = Spain
    FI = Finland
    FR = France 
    HR = Croatia
    HU = Hungary
    IE = Ireland
    IT = Italy
    LT = Lithuania
    LU = Luxembourg
    LV = Latvia
    MT = Malta
    NL = The Netherlands
    PL = Poland
    PT = Portugal
    RO = Romania
    SE = Sweden
    SI = Slovenia
    SK = Slovakia
    XI = Northern Ireland
     */
    verifyVatNumber(vatNumber: string | null | undefined, countryCode: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/Payments/VerifyVatNumber?";
        if (vatNumber !== undefined && vatNumber !== null)
            url_ += "VatNumber=" + encodeURIComponent("" + vatNumber) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyVatNumber(_response);
        });
    }

    protected processVerifyVatNumber(response: AxiosResponse): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse<void>(status, _headers, <any>null));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getOrders(  cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<OrderListItemDto[]>> {
        let url_ = this.baseUrl + "/Payments/GetOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrders(_response);
        });
    }

    protected processGetOrders(response: AxiosResponse): Promise<SwaggerResponse<OrderListItemDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderListItemDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<OrderListItemDto[]>>(new SwaggerResponse<OrderListItemDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<OrderListItemDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getOrder(orderId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<OrderDetailsDto>> {
        let url_ = this.baseUrl + "/Payments/GetOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrder(_response);
        });
    }

    protected processGetOrder(response: AxiosResponse): Promise<SwaggerResponse<OrderDetailsDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderDetailsDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<OrderDetailsDto>>(new SwaggerResponse<OrderDetailsDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<OrderDetailsDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInvoice(orderId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<InvoiceDto>> {
        let url_ = this.baseUrl + "/Payments/GetInvoice?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoice(_response);
        });
    }

    protected processGetInvoice(response: AxiosResponse): Promise<SwaggerResponse<InvoiceDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<InvoiceDto>>(new SwaggerResponse<InvoiceDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<InvoiceDto>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class ProfessionClient extends ClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getProfessionsOfCurrentUser(  cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<ProfessionDto[]>> {
        let url_ = this.baseUrl + "/Profession/GetProfessionsOfCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfessionsOfCurrentUser(_response);
        });
    }

    protected processGetProfessionsOfCurrentUser(response: AxiosResponse): Promise<SwaggerResponse<ProfessionDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfessionDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<ProfessionDto[]>>(new SwaggerResponse<ProfessionDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<ProfessionDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getQuestionsForProfession(professionId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<QuestionDto[]>> {
        let url_ = this.baseUrl + "/Profession/GetQuestionsForProfession?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "ProfessionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionsForProfession(_response);
        });
    }

    protected processGetQuestionsForProfession(response: AxiosResponse): Promise<SwaggerResponse<QuestionDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<QuestionDto[]>>(new SwaggerResponse<QuestionDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<QuestionDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    createProfession(inputModel: ProfessionCreateInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<ProfessionDto>> {
        let url_ = this.baseUrl + "/Profession/CreateProfession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProfession(_response);
        });
    }

    protected processCreateProfession(response: AxiosResponse): Promise<SwaggerResponse<ProfessionDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfessionDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<ProfessionDto>>(new SwaggerResponse<ProfessionDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<ProfessionDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getProfession(professionId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<ProfessionDto>> {
        let url_ = this.baseUrl + "/Profession/GetProfession?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "ProfessionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfession(_response);
        });
    }

    protected processGetProfession(response: AxiosResponse): Promise<SwaggerResponse<ProfessionDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfessionDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<ProfessionDto>>(new SwaggerResponse<ProfessionDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<ProfessionDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateProfession(inputModel: ProfessionUpdateInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<ProfessionDto>> {
        let url_ = this.baseUrl + "/Profession/UpdateProfession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProfession(_response);
        });
    }

    protected processUpdateProfession(response: AxiosResponse): Promise<SwaggerResponse<ProfessionDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfessionDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<ProfessionDto>>(new SwaggerResponse<ProfessionDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<ProfessionDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    deleteProfession(inputModel: ProfessionDeleteInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<ProfessionDto>> {
        let url_ = this.baseUrl + "/Profession/DeleteProfession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProfession(_response);
        });
    }

    protected processDeleteProfession(response: AxiosResponse): Promise<SwaggerResponse<ProfessionDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfessionDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<ProfessionDto>>(new SwaggerResponse<ProfessionDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<ProfessionDto>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class QuestionClient extends ClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createQuestion(inputModel: QuestionCreateInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<QuestionDto>> {
        let url_ = this.baseUrl + "/Question/CreateQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQuestion(_response);
        });
    }

    protected processCreateQuestion(response: AxiosResponse): Promise<SwaggerResponse<QuestionDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuestionDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<QuestionDto>>(new SwaggerResponse<QuestionDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<QuestionDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getQuestion(questionId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<QuestionDto>> {
        let url_ = this.baseUrl + "/Question/GetQuestion?";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "QuestionId=" + encodeURIComponent("" + questionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestion(_response);
        });
    }

    protected processGetQuestion(response: AxiosResponse): Promise<SwaggerResponse<QuestionDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuestionDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<QuestionDto>>(new SwaggerResponse<QuestionDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<QuestionDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateQuestion(inputModel: QuestionUpdateInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<QuestionDto>> {
        let url_ = this.baseUrl + "/Question/UpdateQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQuestion(_response);
        });
    }

    protected processUpdateQuestion(response: AxiosResponse): Promise<SwaggerResponse<QuestionDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuestionDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<QuestionDto>>(new SwaggerResponse<QuestionDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<QuestionDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    deleteQuestion(inputModel: QuestionDeleteInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<QuestionDto>> {
        let url_ = this.baseUrl + "/Question/DeleteQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQuestion(_response);
        });
    }

    protected processDeleteQuestion(response: AxiosResponse): Promise<SwaggerResponse<QuestionDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuestionDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<QuestionDto>>(new SwaggerResponse<QuestionDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<QuestionDto>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class SettingsClient extends ClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getConfiguration(  cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<ConfigurationDto>> {
        let url_ = this.baseUrl + "/Settings/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConfiguration(_response);
        });
    }

    protected processGetConfiguration(response: AxiosResponse): Promise<SwaggerResponse<ConfigurationDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigurationDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<ConfigurationDto>>(new SwaggerResponse<ConfigurationDto>(status, _headers, result200));
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<ConfigurationDto>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class StatisticsClient extends ClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getInstanceGlobalStatistics(gameInstanceId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<InstanceGlobalStatisticsDto>> {
        let url_ = this.baseUrl + "/Statistics/GetInstanceGlobalStatistics?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstanceGlobalStatistics(_response);
        });
    }

    protected processGetInstanceGlobalStatistics(response: AxiosResponse): Promise<SwaggerResponse<InstanceGlobalStatisticsDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InstanceGlobalStatisticsDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<InstanceGlobalStatisticsDto>>(new SwaggerResponse<InstanceGlobalStatisticsDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<InstanceGlobalStatisticsDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInstanceGlobalStatisticsForPlayer(gameInstanceId: string | undefined, email: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<InstanceGlobalStatisticsForPlayerDto>> {
        let url_ = this.baseUrl + "/Statistics/GetInstanceGlobalStatisticsForPlayer?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstanceGlobalStatisticsForPlayer(_response);
        });
    }

    protected processGetInstanceGlobalStatisticsForPlayer(response: AxiosResponse): Promise<SwaggerResponse<InstanceGlobalStatisticsForPlayerDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InstanceGlobalStatisticsForPlayerDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<InstanceGlobalStatisticsForPlayerDto>>(new SwaggerResponse<InstanceGlobalStatisticsForPlayerDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<InstanceGlobalStatisticsForPlayerDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInstancePlayersStatistics(gameInstanceId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<InstancePlayersStatisticsDto[]>> {
        let url_ = this.baseUrl + "/Statistics/GetInstancePlayersStatistics?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstancePlayersStatistics(_response);
        });
    }

    protected processGetInstancePlayersStatistics(response: AxiosResponse): Promise<SwaggerResponse<InstancePlayersStatisticsDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstancePlayersStatisticsDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<InstancePlayersStatisticsDto[]>>(new SwaggerResponse<InstancePlayersStatisticsDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<InstancePlayersStatisticsDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInstancePlayersCV(gameInstanceId: string | undefined, playerEmail: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<PlayerInstanceDetailsDto>> {
        let url_ = this.baseUrl + "/Statistics/GetInstancePlayersCV?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        if (playerEmail !== undefined && playerEmail !== null)
            url_ += "playerEmail=" + encodeURIComponent("" + playerEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstancePlayersCV(_response);
        });
    }

    protected processGetInstancePlayersCV(response: AxiosResponse): Promise<SwaggerResponse<PlayerInstanceDetailsDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlayerInstanceDetailsDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<PlayerInstanceDetailsDto>>(new SwaggerResponse<PlayerInstanceDetailsDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<PlayerInstanceDetailsDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInstanceGameCV(gameInstanceId: string | undefined, instanceId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<PlayerInstanceDetailsDto>> {
        let url_ = this.baseUrl + "/Statistics/GetInstanceGameCV?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        if (instanceId === null)
            throw new Error("The parameter 'instanceId' cannot be null.");
        else if (instanceId !== undefined)
            url_ += "instanceId=" + encodeURIComponent("" + instanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstanceGameCV(_response);
        });
    }

    protected processGetInstanceGameCV(response: AxiosResponse): Promise<SwaggerResponse<PlayerInstanceDetailsDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlayerInstanceDetailsDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<PlayerInstanceDetailsDto>>(new SwaggerResponse<PlayerInstanceDetailsDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<PlayerInstanceDetailsDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInstancePlayersCVById(instanceId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<PlayerInstanceDetailsDto>> {
        let url_ = this.baseUrl + "/Statistics/GetInstancePlayersCVById?";
        if (instanceId === null)
            throw new Error("The parameter 'instanceId' cannot be null.");
        else if (instanceId !== undefined)
            url_ += "InstanceId=" + encodeURIComponent("" + instanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstancePlayersCVById(_response);
        });
    }

    protected processGetInstancePlayersCVById(response: AxiosResponse): Promise<SwaggerResponse<PlayerInstanceDetailsDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlayerInstanceDetailsDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<PlayerInstanceDetailsDto>>(new SwaggerResponse<PlayerInstanceDetailsDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<PlayerInstanceDetailsDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInstanceGameStatistics(gameInstanceId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<InstanceGameStatisticsDto[]>> {
        let url_ = this.baseUrl + "/Statistics/GetInstanceGameStatistics?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstanceGameStatistics(_response);
        });
    }

    protected processGetInstanceGameStatistics(response: AxiosResponse): Promise<SwaggerResponse<InstanceGameStatisticsDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstanceGameStatisticsDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<InstanceGameStatisticsDto[]>>(new SwaggerResponse<InstanceGameStatisticsDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<InstanceGameStatisticsDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    exportPlayersStatistics(gameInstanceId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/Statistics/ExportPlayersStatistics?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPlayersStatistics(_response);
        });
    }

    protected processExportPlayersStatistics(response: AxiosResponse): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, { fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers }));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    exportGamesStatistics(gameInstanceId: string | undefined, localTimeOffset: number | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/Statistics/ExportGamesStatistics?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        if (localTimeOffset === null)
            throw new Error("The parameter 'localTimeOffset' cannot be null.");
        else if (localTimeOffset !== undefined)
            url_ += "LocalTimeOffset=" + encodeURIComponent("" + localTimeOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportGamesStatistics(_response);
        });
    }

    protected processExportGamesStatistics(response: AxiosResponse): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, { fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers }));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInstancePlayerStatisticsCSV(gameInstanceId: string | undefined, email: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/Statistics/GetInstancePlayerStatisticsCSV?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstancePlayerStatisticsCSV(_response);
        });
    }

    protected processGetInstancePlayerStatisticsCSV(response: AxiosResponse): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, { fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers }));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInstanceGameStatisticsCSVByPlayer(gameInstanceId: string | undefined, professionId: string | null | undefined, email: string | null | undefined, localTimeOffset: number | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/Statistics/GetInstanceGameStatisticsCSVByPlayer?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        if (professionId !== undefined && professionId !== null)
            url_ += "ProfessionId=" + encodeURIComponent("" + professionId) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (localTimeOffset === null)
            throw new Error("The parameter 'localTimeOffset' cannot be null.");
        else if (localTimeOffset !== undefined)
            url_ += "LocalTimeOffset=" + encodeURIComponent("" + localTimeOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstanceGameStatisticsCSVByPlayer(_response);
        });
    }

    protected processGetInstanceGameStatisticsCSVByPlayer(response: AxiosResponse): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, { fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers }));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInstanceOneGameLogsStatisticsCSV(gameInstanceId: string | undefined, instanceId: string | undefined, localTimeOffset: number | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/Statistics/GetInstanceOneGameLogsStatisticsCSV?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        if (instanceId === null)
            throw new Error("The parameter 'instanceId' cannot be null.");
        else if (instanceId !== undefined)
            url_ += "InstanceId=" + encodeURIComponent("" + instanceId) + "&";
        if (localTimeOffset === null)
            throw new Error("The parameter 'localTimeOffset' cannot be null.");
        else if (localTimeOffset !== undefined)
            url_ += "LocalTimeOffset=" + encodeURIComponent("" + localTimeOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstanceOneGameLogsStatisticsCSV(_response);
        });
    }

    protected processGetInstanceOneGameLogsStatisticsCSV(response: AxiosResponse): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, { fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers }));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInstanceOneGameAnswerStatisticsCSV(gameInstanceId: string | undefined, instanceId: string | undefined, localTimeOffset: number | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/Statistics/GetInstanceOneGameAnswerStatisticsCSV?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        if (instanceId === null)
            throw new Error("The parameter 'instanceId' cannot be null.");
        else if (instanceId !== undefined)
            url_ += "InstanceId=" + encodeURIComponent("" + instanceId) + "&";
        if (localTimeOffset === null)
            throw new Error("The parameter 'localTimeOffset' cannot be null.");
        else if (localTimeOffset !== undefined)
            url_ += "LocalTimeOffset=" + encodeURIComponent("" + localTimeOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstanceOneGameAnswerStatisticsCSV(_response);
        });
    }

    protected processGetInstanceOneGameAnswerStatisticsCSV(response: AxiosResponse): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, { fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers }));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInstanceGameStatisticsByPlayer(gameInstanceId: string | undefined, professionId: string | null | undefined, email: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<InstancePlayerGameStatisticsDto[]>> {
        let url_ = this.baseUrl + "/Statistics/GetInstanceGameStatisticsByPlayer?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        if (professionId !== undefined && professionId !== null)
            url_ += "ProfessionId=" + encodeURIComponent("" + professionId) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstanceGameStatisticsByPlayer(_response);
        });
    }

    protected processGetInstanceGameStatisticsByPlayer(response: AxiosResponse): Promise<SwaggerResponse<InstancePlayerGameStatisticsDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstancePlayerGameStatisticsDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<InstancePlayerGameStatisticsDto[]>>(new SwaggerResponse<InstancePlayerGameStatisticsDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<InstancePlayerGameStatisticsDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInstanceOneGameStatistics(gameInstanceId: string | undefined, instanceId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<InstanceOneGameStatisticDto>> {
        let url_ = this.baseUrl + "/Statistics/GetInstanceOneGameStatistics?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        if (instanceId === null)
            throw new Error("The parameter 'instanceId' cannot be null.");
        else if (instanceId !== undefined)
            url_ += "instanceId=" + encodeURIComponent("" + instanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstanceOneGameStatistics(_response);
        });
    }

    protected processGetInstanceOneGameStatistics(response: AxiosResponse): Promise<SwaggerResponse<InstanceOneGameStatisticDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InstanceOneGameStatisticDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<InstanceOneGameStatisticDto>>(new SwaggerResponse<InstanceOneGameStatisticDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<InstanceOneGameStatisticDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getInstancePlayerStatistics(gameInstanceId: string | undefined, email: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<InstancePlayerStatisticsDto[]>> {
        let url_ = this.baseUrl + "/Statistics/GetInstancePlayerStatistics?";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInstancePlayerStatistics(_response);
        });
    }

    protected processGetInstancePlayerStatistics(response: AxiosResponse): Promise<SwaggerResponse<InstancePlayerStatisticsDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstancePlayerStatisticsDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<InstancePlayerStatisticsDto[]>>(new SwaggerResponse<InstancePlayerStatisticsDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<InstancePlayerStatisticsDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getPlayerProfile(email: string | null | undefined, gameInstanceId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<PlayerProfileDto>> {
        let url_ = this.baseUrl + "/Statistics/GetPlayerProfile?";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (gameInstanceId === null)
            throw new Error("The parameter 'gameInstanceId' cannot be null.");
        else if (gameInstanceId !== undefined)
            url_ += "GameInstanceId=" + encodeURIComponent("" + gameInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlayerProfile(_response);
        });
    }

    protected processGetPlayerProfile(response: AxiosResponse): Promise<SwaggerResponse<PlayerProfileDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlayerProfileDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<PlayerProfileDto>>(new SwaggerResponse<PlayerProfileDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<PlayerProfileDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updatePlayerProfile(inputModel: PlayerProfileUpdateInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<PlayerProfileDto>> {
        let url_ = this.baseUrl + "/Statistics/UpdatePlayerProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePlayerProfile(_response);
        });
    }

    protected processUpdatePlayerProfile(response: AxiosResponse): Promise<SwaggerResponse<PlayerProfileDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlayerProfileDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<PlayerProfileDto>>(new SwaggerResponse<PlayerProfileDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<PlayerProfileDto>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class UserAdminClient extends ClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUsersList(  cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<AdminUserListItemDto[]>> {
        let url_ = this.baseUrl + "/GetUsersList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersList(_response);
        });
    }

    protected processGetUsersList(response: AxiosResponse): Promise<SwaggerResponse<AdminUserListItemDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminUserListItemDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<AdminUserListItemDto[]>>(new SwaggerResponse<AdminUserListItemDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<AdminUserListItemDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateDataUser(inputModel: AdminUserUpdateInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<AdminUserListItemDto>> {
        let url_ = this.baseUrl + "/UpdateDataUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDataUser(_response);
        });
    }

    protected processUpdateDataUser(response: AxiosResponse): Promise<SwaggerResponse<AdminUserListItemDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdminUserListItemDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<AdminUserListItemDto>>(new SwaggerResponse<AdminUserListItemDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<AdminUserListItemDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    deleteUser(inputModel: AdminUserDeleteUserInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<AdminUserListItemDto>> {
        let url_ = this.baseUrl + "/DeleteUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<SwaggerResponse<AdminUserListItemDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdminUserListItemDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<AdminUserListItemDto>>(new SwaggerResponse<AdminUserListItemDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<AdminUserListItemDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getUser(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<AdminUserListItemDto>> {
        let url_ = this.baseUrl + "/GetUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<SwaggerResponse<AdminUserListItemDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdminUserListItemDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<AdminUserListItemDto>>(new SwaggerResponse<AdminUserListItemDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<AdminUserListItemDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getUserData(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<AdminUserDataDto>> {
        let url_ = this.baseUrl + "/GetUserData?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserData(_response);
        });
    }

    protected processGetUserData(response: AxiosResponse): Promise<SwaggerResponse<AdminUserDataDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdminUserDataDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<AdminUserDataDto>>(new SwaggerResponse<AdminUserDataDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<AdminUserDataDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getPaymentOrders(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<OrderListItemAdminDataDto[]>> {
        let url_ = this.baseUrl + "/GetPaymentOrders?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentOrders(_response);
        });
    }

    protected processGetPaymentOrders(response: AxiosResponse): Promise<SwaggerResponse<OrderListItemAdminDataDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderListItemAdminDataDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<OrderListItemAdminDataDto[]>>(new SwaggerResponse<OrderListItemAdminDataDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<OrderListItemAdminDataDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getGameInstancesByUser(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<GameInstanceAdminDataDto[]>> {
        let url_ = this.baseUrl + "/GetGameInstancesByUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGameInstancesByUser(_response);
        });
    }

    protected processGetGameInstancesByUser(response: AxiosResponse): Promise<SwaggerResponse<GameInstanceAdminDataDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GameInstanceAdminDataDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<GameInstanceAdminDataDto[]>>(new SwaggerResponse<GameInstanceAdminDataDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<GameInstanceAdminDataDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getProfessionsOfCurrentUser(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<ProfessionAdminDataDto[]>> {
        let url_ = this.baseUrl + "/GetProfessionsOfCurrentUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfessionsOfCurrentUser(_response);
        });
    }

    protected processGetProfessionsOfCurrentUser(response: AxiosResponse): Promise<SwaggerResponse<ProfessionAdminDataDto[]>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfessionAdminDataDto.fromJS(item));
            }
            return Promise.resolve<SwaggerResponse<ProfessionAdminDataDto[]>>(new SwaggerResponse<ProfessionAdminDataDto[]>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<ProfessionAdminDataDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class UserClient extends ClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    authenticate(model: AuthenticateRequest , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<AuthenticateResponse>> {
        let url_ = this.baseUrl + "/User/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<SwaggerResponse<AuthenticateResponse>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResponse.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<AuthenticateResponse>>(new SwaggerResponse<AuthenticateResponse>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<AuthenticateResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    register(inputModel: UserRegisterInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<UserDto>> {
        let url_ = this.baseUrl + "/User/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<SwaggerResponse<UserDto>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<SwaggerResponse<UserDto>>(new SwaggerResponse<UserDto>(status, _headers, result200));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<UserDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    activate(activationCode: string | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/User/Activate?";
        if (activationCode === null)
            throw new Error("The parameter 'activationCode' cannot be null.");
        else if (activationCode !== undefined)
            url_ += "activationCode=" + encodeURIComponent("" + activationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse<void>(status, _headers, <any>null));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    forgotPasswordRequest(email: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/User/ForgotPasswordRequest?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPasswordRequest(_response);
        });
    }

    protected processForgotPasswordRequest(response: AxiosResponse): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse<void>(status, _headers, <any>null));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    forgotPasswordConfirmation(inputModel: ForgotPasswordConfirmationInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/User/ForgotPasswordConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPasswordConfirmation(_response);
        });
    }

    protected processForgotPasswordConfirmation(response: AxiosResponse): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse<void>(status, _headers, <any>null));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    changePassword(inputModel: ChangePasswordInputModel , cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse<void>(status, _headers, <any>null));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateLanguage(  cancelToken?: CancelToken | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/User/UpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLanguage(_response);
        });
    }

    protected processUpdateLanguage(response: AxiosResponse): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse<void>(status, _headers, <any>null));
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class DiscountAdminDto implements IDiscountAdminDto {
    id!: string;
    email?: string | null;
    code!: string;
    discount!: number;
    isActive!: boolean;

    constructor(data?: IDiscountAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.discount = _data["discount"] !== undefined ? _data["discount"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): DiscountAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["discount"] = this.discount !== undefined ? this.discount : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data; 
    }
}

export interface IDiscountAdminDto {
    id: string;
    email?: string | null;
    code: string;
    discount: number;
    isActive: boolean;
}

export class DiscountAdminUpdateInputModel implements IDiscountAdminUpdateInputModel {
    id!: string;
    email?: string | null;
    code!: string;
    discount!: number;
    isActive!: boolean;

    constructor(data?: IDiscountAdminUpdateInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.discount = _data["discount"] !== undefined ? _data["discount"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): DiscountAdminUpdateInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountAdminUpdateInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["discount"] = this.discount !== undefined ? this.discount : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data; 
    }
}

export interface IDiscountAdminUpdateInputModel {
    id: string;
    email?: string | null;
    code: string;
    discount: number;
    isActive: boolean;
}

export class OrderListItemAdminDataDto implements IOrderListItemAdminDataDto {
    id!: string;
    userId?: string | null;
    orderNumber?: string | null;
    offerTitle?: string | null;
    createdAt?: moment.Moment | null;
    updatedAt?: moment.Moment | null;
    priceInfo?: PriceInfo | null;
    paymentStatus!: PaymentStatus;
    isInvoiceCreated!: boolean;
    gameInstanceId!: string;
    gameInstanceTitle?: string | null;
    invoiceCode?: string | null;
    companyName?: string | null;
    buyerIdentifier?: string | null;
    email?: string | null;

    constructor(data?: IOrderListItemAdminDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.offerTitle = _data["offerTitle"] !== undefined ? _data["offerTitle"] : <any>null;
            this.createdAt = _data["createdAt"] ? moment.parseZone(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? moment.parseZone(_data["updatedAt"].toString()) : <any>null;
            this.priceInfo = _data["priceInfo"] ? PriceInfo.fromJS(_data["priceInfo"]) : <any>null;
            this.paymentStatus = _data["paymentStatus"] !== undefined ? _data["paymentStatus"] : <any>null;
            this.isInvoiceCreated = _data["isInvoiceCreated"] !== undefined ? _data["isInvoiceCreated"] : <any>null;
            this.gameInstanceId = _data["gameInstanceId"] !== undefined ? _data["gameInstanceId"] : <any>null;
            this.gameInstanceTitle = _data["gameInstanceTitle"] !== undefined ? _data["gameInstanceTitle"] : <any>null;
            this.invoiceCode = _data["invoiceCode"] !== undefined ? _data["invoiceCode"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.buyerIdentifier = _data["buyerIdentifier"] !== undefined ? _data["buyerIdentifier"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): OrderListItemAdminDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderListItemAdminDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["offerTitle"] = this.offerTitle !== undefined ? this.offerTitle : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString(true) : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString(true) : <any>null;
        data["priceInfo"] = this.priceInfo ? this.priceInfo.toJSON() : <any>null;
        data["paymentStatus"] = this.paymentStatus !== undefined ? this.paymentStatus : <any>null;
        data["isInvoiceCreated"] = this.isInvoiceCreated !== undefined ? this.isInvoiceCreated : <any>null;
        data["gameInstanceId"] = this.gameInstanceId !== undefined ? this.gameInstanceId : <any>null;
        data["gameInstanceTitle"] = this.gameInstanceTitle !== undefined ? this.gameInstanceTitle : <any>null;
        data["invoiceCode"] = this.invoiceCode !== undefined ? this.invoiceCode : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["buyerIdentifier"] = this.buyerIdentifier !== undefined ? this.buyerIdentifier : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data; 
    }
}

export interface IOrderListItemAdminDataDto {
    id: string;
    userId?: string | null;
    orderNumber?: string | null;
    offerTitle?: string | null;
    createdAt?: moment.Moment | null;
    updatedAt?: moment.Moment | null;
    priceInfo?: PriceInfo | null;
    paymentStatus: PaymentStatus;
    isInvoiceCreated: boolean;
    gameInstanceId: string;
    gameInstanceTitle?: string | null;
    invoiceCode?: string | null;
    companyName?: string | null;
    buyerIdentifier?: string | null;
    email?: string | null;
}

export class PriceInfo implements IPriceInfo {
    netPrice!: number;
    discountValue?: number | null;
    netPriceAfterDiscount!: number;
    vat!: number;
    vatFractionalNumber!: number;
    vatAmount!: number;
    finalPrice!: number;
    currency!: Currency;
    invoiceType!: InvoiceType;

    constructor(data?: IPriceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.netPrice = _data["netPrice"] !== undefined ? _data["netPrice"] : <any>null;
            this.discountValue = _data["discountValue"] !== undefined ? _data["discountValue"] : <any>null;
            this.netPriceAfterDiscount = _data["netPriceAfterDiscount"] !== undefined ? _data["netPriceAfterDiscount"] : <any>null;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : <any>null;
            this.vatFractionalNumber = _data["vatFractionalNumber"] !== undefined ? _data["vatFractionalNumber"] : <any>null;
            this.vatAmount = _data["vatAmount"] !== undefined ? _data["vatAmount"] : <any>null;
            this.finalPrice = _data["finalPrice"] !== undefined ? _data["finalPrice"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.invoiceType = _data["invoiceType"] !== undefined ? _data["invoiceType"] : <any>null;
        }
    }

    static fromJS(data: any): PriceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PriceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["netPrice"] = this.netPrice !== undefined ? this.netPrice : <any>null;
        data["discountValue"] = this.discountValue !== undefined ? this.discountValue : <any>null;
        data["netPriceAfterDiscount"] = this.netPriceAfterDiscount !== undefined ? this.netPriceAfterDiscount : <any>null;
        data["vat"] = this.vat !== undefined ? this.vat : <any>null;
        data["vatFractionalNumber"] = this.vatFractionalNumber !== undefined ? this.vatFractionalNumber : <any>null;
        data["vatAmount"] = this.vatAmount !== undefined ? this.vatAmount : <any>null;
        data["finalPrice"] = this.finalPrice !== undefined ? this.finalPrice : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["invoiceType"] = this.invoiceType !== undefined ? this.invoiceType : <any>null;
        return data; 
    }
}

export interface IPriceInfo {
    netPrice: number;
    discountValue?: number | null;
    netPriceAfterDiscount: number;
    vat: number;
    vatFractionalNumber: number;
    vatAmount: number;
    finalPrice: number;
    currency: Currency;
    invoiceType: InvoiceType;
}

export enum Currency {
    PLN = "PLN",
    USD = "USD",
    EUR = "EUR",
}

export enum InvoiceType {
    Polish = "Polish",
    EuropeanUnion = "EuropeanUnion",
    Other = "Other",
}

export enum PaymentStatus {
    New = "New",
    Pending = "Pending",
    WaitingForConfirmation = "WaitingForConfirmation",
    Completed = "Completed",
    Canceled = "Canceled",
    Rejected = "Rejected",
}

export class GameTemplateDto implements IGameTemplateDto {
    id!: string;
    title?: string | null;
    type!: GameType;

    constructor(data?: IGameTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): GameTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data; 
    }
}

export interface IGameTemplateDto {
    id: string;
    title?: string | null;
    type: GameType;
}

export enum GameType {
    Undefined = "Undefined",
    SpaceRescue = "SpaceRescue",
    DesertAdventure = "DesertAdventure",
    LittleWitch = "LittleWitch",
    FroggyPrincess = "FroggyPrincess",
    SpeedRace = "SpeedRace",
    Pirates = "Pirates",
    SkyFlight = "SkyFlight",
    MazeGame = "MazeGame",
}

export class GameInstanceDto implements IGameInstanceDto {
    id!: string;
    title?: string | null;
    userId!: string;
    url?: string | null;
    gameTemplateId!: string;
    gameTemplate?: GameTemplateDto | null;
    isPublic!: boolean;
    validUntil?: moment.Moment | null;
    playableFrom?: moment.Moment | null;
    playableTo?: moment.Moment | null;
    assignedProfessions?: string[] | null;
    settings?: string | null;
    lastPaymentBaseData?: PaymentBaseData | null;

    constructor(data?: IGameInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.gameTemplateId = _data["gameTemplateId"] !== undefined ? _data["gameTemplateId"] : <any>null;
            this.gameTemplate = _data["gameTemplate"] ? GameTemplateDto.fromJS(_data["gameTemplate"]) : <any>null;
            this.isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : <any>null;
            this.validUntil = _data["validUntil"] ? moment.parseZone(_data["validUntil"].toString()) : <any>null;
            this.playableFrom = _data["playableFrom"] ? moment.parseZone(_data["playableFrom"].toString()) : <any>null;
            this.playableTo = _data["playableTo"] ? moment.parseZone(_data["playableTo"].toString()) : <any>null;
            if (Array.isArray(_data["assignedProfessions"])) {
                this.assignedProfessions = [] as any;
                for (let item of _data["assignedProfessions"])
                    this.assignedProfessions!.push(item);
            }
            this.settings = _data["settings"] !== undefined ? _data["settings"] : <any>null;
            this.lastPaymentBaseData = _data["lastPaymentBaseData"] ? PaymentBaseData.fromJS(_data["lastPaymentBaseData"]) : <any>null;
        }
    }

    static fromJS(data: any): GameInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["gameTemplateId"] = this.gameTemplateId !== undefined ? this.gameTemplateId : <any>null;
        data["gameTemplate"] = this.gameTemplate ? this.gameTemplate.toJSON() : <any>null;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString(true) : <any>null;
        data["playableFrom"] = this.playableFrom ? this.playableFrom.toISOString(true) : <any>null;
        data["playableTo"] = this.playableTo ? this.playableTo.toISOString(true) : <any>null;
        if (Array.isArray(this.assignedProfessions)) {
            data["assignedProfessions"] = [];
            for (let item of this.assignedProfessions)
                data["assignedProfessions"].push(item);
        }
        data["settings"] = this.settings !== undefined ? this.settings : <any>null;
        data["lastPaymentBaseData"] = this.lastPaymentBaseData ? this.lastPaymentBaseData.toJSON() : <any>null;
        return data; 
    }
}

export interface IGameInstanceDto {
    id: string;
    title?: string | null;
    userId: string;
    url?: string | null;
    gameTemplateId: string;
    gameTemplate?: GameTemplateDto | null;
    isPublic: boolean;
    validUntil?: moment.Moment | null;
    playableFrom?: moment.Moment | null;
    playableTo?: moment.Moment | null;
    assignedProfessions?: string[] | null;
    settings?: string | null;
    lastPaymentBaseData?: PaymentBaseData | null;
}

export class PaymentBaseData implements IPaymentBaseData {
    isPaymentActive!: boolean;
    activePaymentStatus?: PaymentStatus | null;

    constructor(data?: IPaymentBaseData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPaymentActive = _data["isPaymentActive"] !== undefined ? _data["isPaymentActive"] : <any>null;
            this.activePaymentStatus = _data["activePaymentStatus"] !== undefined ? _data["activePaymentStatus"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentBaseData {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBaseData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPaymentActive"] = this.isPaymentActive !== undefined ? this.isPaymentActive : <any>null;
        data["activePaymentStatus"] = this.activePaymentStatus !== undefined ? this.activePaymentStatus : <any>null;
        return data; 
    }
}

export interface IPaymentBaseData {
    isPaymentActive: boolean;
    activePaymentStatus?: PaymentStatus | null;
}

export class GameInstanceCreateInputModel implements IGameInstanceCreateInputModel {
    title!: string;
    gameTemplateId!: string;
    validUntil?: moment.Moment | null;
    isPublic!: boolean;
    playableFrom?: moment.Moment | null;
    playableTo?: moment.Moment | null;
    settings?: string | null;

    constructor(data?: IGameInstanceCreateInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.gameTemplateId = _data["gameTemplateId"] !== undefined ? _data["gameTemplateId"] : <any>null;
            this.validUntil = _data["validUntil"] ? moment.parseZone(_data["validUntil"].toString()) : <any>null;
            this.isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : <any>null;
            this.playableFrom = _data["playableFrom"] ? moment.parseZone(_data["playableFrom"].toString()) : <any>null;
            this.playableTo = _data["playableTo"] ? moment.parseZone(_data["playableTo"].toString()) : <any>null;
            this.settings = _data["settings"] !== undefined ? _data["settings"] : <any>null;
        }
    }

    static fromJS(data: any): GameInstanceCreateInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new GameInstanceCreateInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["gameTemplateId"] = this.gameTemplateId !== undefined ? this.gameTemplateId : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString(true) : <any>null;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : <any>null;
        data["playableFrom"] = this.playableFrom ? this.playableFrom.toISOString(true) : <any>null;
        data["playableTo"] = this.playableTo ? this.playableTo.toISOString(true) : <any>null;
        data["settings"] = this.settings !== undefined ? this.settings : <any>null;
        return data; 
    }
}

export interface IGameInstanceCreateInputModel {
    title: string;
    gameTemplateId: string;
    validUntil?: moment.Moment | null;
    isPublic: boolean;
    playableFrom?: moment.Moment | null;
    playableTo?: moment.Moment | null;
    settings?: string | null;
}

export class GameInstanceUpdateInputModel implements IGameInstanceUpdateInputModel {
    gameId!: string;
    title!: string;
    gameTemplateId!: string;
    validUntil?: moment.Moment | null;
    isPublic!: boolean;
    playableFrom?: moment.Moment | null;
    playableTo?: moment.Moment | null;
    assignedProfessions?: string[] | null;
    settings?: string | null;

    constructor(data?: IGameInstanceUpdateInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"] !== undefined ? _data["gameId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.gameTemplateId = _data["gameTemplateId"] !== undefined ? _data["gameTemplateId"] : <any>null;
            this.validUntil = _data["validUntil"] ? moment.parseZone(_data["validUntil"].toString()) : <any>null;
            this.isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : <any>null;
            this.playableFrom = _data["playableFrom"] ? moment.parseZone(_data["playableFrom"].toString()) : <any>null;
            this.playableTo = _data["playableTo"] ? moment.parseZone(_data["playableTo"].toString()) : <any>null;
            if (Array.isArray(_data["assignedProfessions"])) {
                this.assignedProfessions = [] as any;
                for (let item of _data["assignedProfessions"])
                    this.assignedProfessions!.push(item);
            }
            this.settings = _data["settings"] !== undefined ? _data["settings"] : <any>null;
        }
    }

    static fromJS(data: any): GameInstanceUpdateInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new GameInstanceUpdateInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId !== undefined ? this.gameId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["gameTemplateId"] = this.gameTemplateId !== undefined ? this.gameTemplateId : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString(true) : <any>null;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : <any>null;
        data["playableFrom"] = this.playableFrom ? this.playableFrom.toISOString(true) : <any>null;
        data["playableTo"] = this.playableTo ? this.playableTo.toISOString(true) : <any>null;
        if (Array.isArray(this.assignedProfessions)) {
            data["assignedProfessions"] = [];
            for (let item of this.assignedProfessions)
                data["assignedProfessions"].push(item);
        }
        data["settings"] = this.settings !== undefined ? this.settings : <any>null;
        return data; 
    }
}

export interface IGameInstanceUpdateInputModel {
    gameId: string;
    title: string;
    gameTemplateId: string;
    validUntil?: moment.Moment | null;
    isPublic: boolean;
    playableFrom?: moment.Moment | null;
    playableTo?: moment.Moment | null;
    assignedProfessions?: string[] | null;
    settings?: string | null;
}

export class GameInstanceDeleteInputModel implements IGameInstanceDeleteInputModel {
    gameId!: string;

    constructor(data?: IGameInstanceDeleteInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"] !== undefined ? _data["gameId"] : <any>null;
        }
    }

    static fromJS(data: any): GameInstanceDeleteInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new GameInstanceDeleteInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId !== undefined ? this.gameId : <any>null;
        return data; 
    }
}

export interface IGameInstanceDeleteInputModel {
    gameId: string;
}

export class AssignableProfessionDto implements IAssignableProfessionDto {
    id!: string;
    title?: string | null;
    displayTitle?: string | null;
    isGlobal!: boolean;
    questions?: AssignableProfessionQuestionDto[] | null;

    constructor(data?: IAssignableProfessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.displayTitle = _data["displayTitle"] !== undefined ? _data["displayTitle"] : <any>null;
            this.isGlobal = _data["isGlobal"] !== undefined ? _data["isGlobal"] : <any>null;
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(AssignableProfessionQuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignableProfessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableProfessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["displayTitle"] = this.displayTitle !== undefined ? this.displayTitle : <any>null;
        data["isGlobal"] = this.isGlobal !== undefined ? this.isGlobal : <any>null;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAssignableProfessionDto {
    id: string;
    title?: string | null;
    displayTitle?: string | null;
    isGlobal: boolean;
    questions?: AssignableProfessionQuestionDto[] | null;
}

export class AssignableProfessionQuestionDto implements IAssignableProfessionQuestionDto {
    id!: string;
    name?: string | null;
    children?: AssignableProfessionAnswerDto[] | null;

    constructor(data?: IAssignableProfessionQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(AssignableProfessionAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignableProfessionQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableProfessionQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAssignableProfessionQuestionDto {
    id: string;
    name?: string | null;
    children?: AssignableProfessionAnswerDto[] | null;
}

export class AssignableProfessionAnswerDto implements IAssignableProfessionAnswerDto {
    id!: string;
    name?: string | null;
    isCorrect!: boolean;

    constructor(data?: IAssignableProfessionAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isCorrect = _data["isCorrect"] !== undefined ? _data["isCorrect"] : <any>null;
        }
    }

    static fromJS(data: any): AssignableProfessionAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableProfessionAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isCorrect"] = this.isCorrect !== undefined ? this.isCorrect : <any>null;
        return data; 
    }
}

export interface IAssignableProfessionAnswerDto {
    id: string;
    name?: string | null;
    isCorrect: boolean;
}

export class AdminGameInstanceListItemDto implements IAdminGameInstanceListItemDto {
    id!: string;
    instanceTitle?: string | null;
    gameTitle?: string | null;
    ownerId?: string | null;
    owner?: string | null;
    validUntil?: moment.Moment | null;
    playableFrom?: moment.Moment | null;
    playableTo?: moment.Moment | null;
    createdDate?: moment.Moment | null;
    isDeleted!: boolean;

    constructor(data?: IAdminGameInstanceListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.instanceTitle = _data["instanceTitle"] !== undefined ? _data["instanceTitle"] : <any>null;
            this.gameTitle = _data["gameTitle"] !== undefined ? _data["gameTitle"] : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.owner = _data["owner"] !== undefined ? _data["owner"] : <any>null;
            this.validUntil = _data["validUntil"] ? moment.parseZone(_data["validUntil"].toString()) : <any>null;
            this.playableFrom = _data["playableFrom"] ? moment.parseZone(_data["playableFrom"].toString()) : <any>null;
            this.playableTo = _data["playableTo"] ? moment.parseZone(_data["playableTo"].toString()) : <any>null;
            this.createdDate = _data["createdDate"] ? moment.parseZone(_data["createdDate"].toString()) : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): AdminGameInstanceListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminGameInstanceListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["instanceTitle"] = this.instanceTitle !== undefined ? this.instanceTitle : <any>null;
        data["gameTitle"] = this.gameTitle !== undefined ? this.gameTitle : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["owner"] = this.owner !== undefined ? this.owner : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString(true) : <any>null;
        data["playableFrom"] = this.playableFrom ? this.playableFrom.toISOString(true) : <any>null;
        data["playableTo"] = this.playableTo ? this.playableTo.toISOString(true) : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString(true) : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        return data; 
    }
}

export interface IAdminGameInstanceListItemDto {
    id: string;
    instanceTitle?: string | null;
    gameTitle?: string | null;
    ownerId?: string | null;
    owner?: string | null;
    validUntil?: moment.Moment | null;
    playableFrom?: moment.Moment | null;
    playableTo?: moment.Moment | null;
    createdDate?: moment.Moment | null;
    isDeleted: boolean;
}

export class AdminGameInstanceDto implements IAdminGameInstanceDto {
    id!: string;
    title?: string | null;
    gameTitle?: string | null;
    ownerId?: string | null;
    owner?: string | null;
    validUntil?: moment.Moment | null;
    playableFrom?: moment.Moment | null;
    playableTo?: moment.Moment | null;
    createdDate?: moment.Moment | null;
    isPublic!: boolean;

    constructor(data?: IAdminGameInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.gameTitle = _data["gameTitle"] !== undefined ? _data["gameTitle"] : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.owner = _data["owner"] !== undefined ? _data["owner"] : <any>null;
            this.validUntil = _data["validUntil"] ? moment.parseZone(_data["validUntil"].toString()) : <any>null;
            this.playableFrom = _data["playableFrom"] ? moment.parseZone(_data["playableFrom"].toString()) : <any>null;
            this.playableTo = _data["playableTo"] ? moment.parseZone(_data["playableTo"].toString()) : <any>null;
            this.createdDate = _data["createdDate"] ? moment.parseZone(_data["createdDate"].toString()) : <any>null;
            this.isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : <any>null;
        }
    }

    static fromJS(data: any): AdminGameInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminGameInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["gameTitle"] = this.gameTitle !== undefined ? this.gameTitle : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["owner"] = this.owner !== undefined ? this.owner : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString(true) : <any>null;
        data["playableFrom"] = this.playableFrom ? this.playableFrom.toISOString(true) : <any>null;
        data["playableTo"] = this.playableTo ? this.playableTo.toISOString(true) : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString(true) : <any>null;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : <any>null;
        return data; 
    }
}

export interface IAdminGameInstanceDto {
    id: string;
    title?: string | null;
    gameTitle?: string | null;
    ownerId?: string | null;
    owner?: string | null;
    validUntil?: moment.Moment | null;
    playableFrom?: moment.Moment | null;
    playableTo?: moment.Moment | null;
    createdDate?: moment.Moment | null;
    isPublic: boolean;
}

export class RuntimeGameInstanceDto implements IRuntimeGameInstanceDto {
    gameInstanceId!: string;
    type!: GameType;
    settings?: string | null;
    professions?: RuntimeProfessionOptionDto[] | null;
    termsAndConditionsUrl?: string | null;
    timePerQuestion!: number;
    playableFrom?: moment.Moment | null;
    playableTo?: moment.Moment | null;

    constructor(data?: IRuntimeGameInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameInstanceId = _data["gameInstanceId"] !== undefined ? _data["gameInstanceId"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.settings = _data["settings"] !== undefined ? _data["settings"] : <any>null;
            if (Array.isArray(_data["professions"])) {
                this.professions = [] as any;
                for (let item of _data["professions"])
                    this.professions!.push(RuntimeProfessionOptionDto.fromJS(item));
            }
            this.termsAndConditionsUrl = _data["termsAndConditionsUrl"] !== undefined ? _data["termsAndConditionsUrl"] : <any>null;
            this.timePerQuestion = _data["timePerQuestion"] !== undefined ? _data["timePerQuestion"] : <any>null;
            this.playableFrom = _data["playableFrom"] ? moment.parseZone(_data["playableFrom"].toString()) : <any>null;
            this.playableTo = _data["playableTo"] ? moment.parseZone(_data["playableTo"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): RuntimeGameInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeGameInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameInstanceId"] = this.gameInstanceId !== undefined ? this.gameInstanceId : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["settings"] = this.settings !== undefined ? this.settings : <any>null;
        if (Array.isArray(this.professions)) {
            data["professions"] = [];
            for (let item of this.professions)
                data["professions"].push(item.toJSON());
        }
        data["termsAndConditionsUrl"] = this.termsAndConditionsUrl !== undefined ? this.termsAndConditionsUrl : <any>null;
        data["timePerQuestion"] = this.timePerQuestion !== undefined ? this.timePerQuestion : <any>null;
        data["playableFrom"] = this.playableFrom ? this.playableFrom.toISOString(true) : <any>null;
        data["playableTo"] = this.playableTo ? this.playableTo.toISOString(true) : <any>null;
        return data; 
    }
}

export interface IRuntimeGameInstanceDto {
    gameInstanceId: string;
    type: GameType;
    settings?: string | null;
    professions?: RuntimeProfessionOptionDto[] | null;
    termsAndConditionsUrl?: string | null;
    timePerQuestion: number;
    playableFrom?: moment.Moment | null;
    playableTo?: moment.Moment | null;
}

export class RuntimeProfessionOptionDto implements IRuntimeProfessionOptionDto {
    id!: string;
    name?: string | null;

    constructor(data?: IRuntimeProfessionOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): RuntimeProfessionOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeProfessionOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }
}

export interface IRuntimeProfessionOptionDto {
    id: string;
    name?: string | null;
}

export class PlayerInstanceDto implements IPlayerInstanceDto {
    id!: string;

    constructor(data?: IPlayerInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): PlayerInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data; 
    }
}

export interface IPlayerInstanceDto {
    id: string;
}

export class PlayerInstanceInputModel implements IPlayerInstanceInputModel {
    email!: string;
    name!: string;
    professionId!: string;
    gameInstanceId!: string;

    constructor(data?: IPlayerInstanceInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.professionId = _data["professionId"] !== undefined ? _data["professionId"] : <any>null;
            this.gameInstanceId = _data["gameInstanceId"] !== undefined ? _data["gameInstanceId"] : <any>null;
        }
    }

    static fromJS(data: any): PlayerInstanceInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerInstanceInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["professionId"] = this.professionId !== undefined ? this.professionId : <any>null;
        data["gameInstanceId"] = this.gameInstanceId !== undefined ? this.gameInstanceId : <any>null;
        return data; 
    }
}

export interface IPlayerInstanceInputModel {
    email: string;
    name: string;
    professionId: string;
    gameInstanceId: string;
}

export class PlayerInstanceAnswerDto implements IPlayerInstanceAnswerDto {
    id!: string;
    isCorrectAnswer!: boolean;

    constructor(data?: IPlayerInstanceAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.isCorrectAnswer = _data["isCorrectAnswer"] !== undefined ? _data["isCorrectAnswer"] : <any>null;
        }
    }

    static fromJS(data: any): PlayerInstanceAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerInstanceAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isCorrectAnswer"] = this.isCorrectAnswer !== undefined ? this.isCorrectAnswer : <any>null;
        return data; 
    }
}

export interface IPlayerInstanceAnswerDto {
    id: string;
    isCorrectAnswer: boolean;
}

export class PlayerInstanceAnswerInputModel implements IPlayerInstanceAnswerInputModel {
    playerInstanceId!: string;
    answeredQuestionId!: string;
    answeredQuestion?: string | null;
    answer?: string | null;
    isCorrectAnswer!: boolean;

    constructor(data?: IPlayerInstanceAnswerInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerInstanceId = _data["playerInstanceId"] !== undefined ? _data["playerInstanceId"] : <any>null;
            this.answeredQuestionId = _data["answeredQuestionId"] !== undefined ? _data["answeredQuestionId"] : <any>null;
            this.answeredQuestion = _data["answeredQuestion"] !== undefined ? _data["answeredQuestion"] : <any>null;
            this.answer = _data["answer"] !== undefined ? _data["answer"] : <any>null;
            this.isCorrectAnswer = _data["isCorrectAnswer"] !== undefined ? _data["isCorrectAnswer"] : <any>null;
        }
    }

    static fromJS(data: any): PlayerInstanceAnswerInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerInstanceAnswerInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerInstanceId"] = this.playerInstanceId !== undefined ? this.playerInstanceId : <any>null;
        data["answeredQuestionId"] = this.answeredQuestionId !== undefined ? this.answeredQuestionId : <any>null;
        data["answeredQuestion"] = this.answeredQuestion !== undefined ? this.answeredQuestion : <any>null;
        data["answer"] = this.answer !== undefined ? this.answer : <any>null;
        data["isCorrectAnswer"] = this.isCorrectAnswer !== undefined ? this.isCorrectAnswer : <any>null;
        return data; 
    }
}

export interface IPlayerInstanceAnswerInputModel {
    playerInstanceId: string;
    answeredQuestionId: string;
    answeredQuestion?: string | null;
    answer?: string | null;
    isCorrectAnswer: boolean;
}

export class PlayerInstanceLogDto implements IPlayerInstanceLogDto {
    id!: string;

    constructor(data?: IPlayerInstanceLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): PlayerInstanceLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerInstanceLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data; 
    }
}

export interface IPlayerInstanceLogDto {
    id: string;
}

export class PlayerInstanceLogInputModel implements IPlayerInstanceLogInputModel {
    score!: number;
    playerInstanceId!: string;
    logTrigger?: string | null;

    constructor(data?: IPlayerInstanceLogInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
            this.playerInstanceId = _data["playerInstanceId"] !== undefined ? _data["playerInstanceId"] : <any>null;
            this.logTrigger = _data["logTrigger"] !== undefined ? _data["logTrigger"] : <any>null;
        }
    }

    static fromJS(data: any): PlayerInstanceLogInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerInstanceLogInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score !== undefined ? this.score : <any>null;
        data["playerInstanceId"] = this.playerInstanceId !== undefined ? this.playerInstanceId : <any>null;
        data["logTrigger"] = this.logTrigger !== undefined ? this.logTrigger : <any>null;
        return data; 
    }
}

export interface IPlayerInstanceLogInputModel {
    score: number;
    playerInstanceId: string;
    logTrigger?: string | null;
}

export class PlayerInstanceDetailsInputModel implements IPlayerInstanceDetailsInputModel {
    playerInstanceId!: string;
    cv?: string | null;

    constructor(data?: IPlayerInstanceDetailsInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerInstanceId = _data["playerInstanceId"] !== undefined ? _data["playerInstanceId"] : <any>null;
            this.cv = _data["cv"] !== undefined ? _data["cv"] : <any>null;
        }
    }

    static fromJS(data: any): PlayerInstanceDetailsInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerInstanceDetailsInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerInstanceId"] = this.playerInstanceId !== undefined ? this.playerInstanceId : <any>null;
        data["cv"] = this.cv !== undefined ? this.cv : <any>null;
        return data; 
    }
}

export interface IPlayerInstanceDetailsInputModel {
    playerInstanceId: string;
    cv?: string | null;
}

export class EmailMessageBase implements IEmailMessageBase {
    to?: string | null;
    languageCode?: string | null;
    subjectParam?: string | null;

    constructor(data?: IEmailMessageBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.to = _data["to"] !== undefined ? _data["to"] : <any>null;
            this.languageCode = _data["languageCode"] !== undefined ? _data["languageCode"] : <any>null;
            this.subjectParam = _data["subjectParam"] !== undefined ? _data["subjectParam"] : <any>null;
        }
    }

    static fromJS(data: any): EmailMessageBase {
        data = typeof data === 'object' ? data : {};
        let result = new EmailMessageBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to !== undefined ? this.to : <any>null;
        data["languageCode"] = this.languageCode !== undefined ? this.languageCode : <any>null;
        data["subjectParam"] = this.subjectParam !== undefined ? this.subjectParam : <any>null;
        return data; 
    }
}

export interface IEmailMessageBase {
    to?: string | null;
    languageCode?: string | null;
    subjectParam?: string | null;
}

export class SubmitContactFormInputModel extends EmailMessageBase implements ISubmitContactFormInputModel {
    userName?: string | null;
    userEmail?: string | null;
    userSubject?: string | null;
    userMessage?: string | null;

    constructor(data?: ISubmitContactFormInputModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.userEmail = _data["userEmail"] !== undefined ? _data["userEmail"] : <any>null;
            this.userSubject = _data["userSubject"] !== undefined ? _data["userSubject"] : <any>null;
            this.userMessage = _data["userMessage"] !== undefined ? _data["userMessage"] : <any>null;
        }
    }

    static fromJS(data: any): SubmitContactFormInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitContactFormInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["userEmail"] = this.userEmail !== undefined ? this.userEmail : <any>null;
        data["userSubject"] = this.userSubject !== undefined ? this.userSubject : <any>null;
        data["userMessage"] = this.userMessage !== undefined ? this.userMessage : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface ISubmitContactFormInputModel extends IEmailMessageBase {
    userName?: string | null;
    userEmail?: string | null;
    userSubject?: string | null;
    userMessage?: string | null;
}

export class SubmitEmailFormInputModel extends EmailMessageBase implements ISubmitEmailFormInputModel {
    email?: string | null;

    constructor(data?: ISubmitEmailFormInputModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): SubmitEmailFormInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitEmailFormInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface ISubmitEmailFormInputModel extends IEmailMessageBase {
    email?: string | null;
}

export class PaymentsAdminDto implements IPaymentsAdminDto {
    id!: string;
    userId?: string | null;
    orderNumber?: string | null;
    offerTitle?: string | null;
    createdAt?: moment.Moment | null;
    updatedAt?: moment.Moment | null;
    priceInfo?: PriceInfo | null;
    paymentStatus!: PaymentStatus;
    isInvoiceCreated!: boolean;
    gameInstanceId!: string;
    gameInstanceTitle?: string | null;
    invoiceCode?: string | null;
    companyName?: string | null;
    vatNumber?: string | null;
    buyerIdentifier?: string | null;
    email?: string | null;
    address?: AddressDto | null;
    titleEng?: string | null;
    titlePl?: string | null;

    constructor(data?: IPaymentsAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.offerTitle = _data["offerTitle"] !== undefined ? _data["offerTitle"] : <any>null;
            this.createdAt = _data["createdAt"] ? moment.parseZone(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? moment.parseZone(_data["updatedAt"].toString()) : <any>null;
            this.priceInfo = _data["priceInfo"] ? PriceInfo.fromJS(_data["priceInfo"]) : <any>null;
            this.paymentStatus = _data["paymentStatus"] !== undefined ? _data["paymentStatus"] : <any>null;
            this.isInvoiceCreated = _data["isInvoiceCreated"] !== undefined ? _data["isInvoiceCreated"] : <any>null;
            this.gameInstanceId = _data["gameInstanceId"] !== undefined ? _data["gameInstanceId"] : <any>null;
            this.gameInstanceTitle = _data["gameInstanceTitle"] !== undefined ? _data["gameInstanceTitle"] : <any>null;
            this.invoiceCode = _data["invoiceCode"] !== undefined ? _data["invoiceCode"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.vatNumber = _data["vatNumber"] !== undefined ? _data["vatNumber"] : <any>null;
            this.buyerIdentifier = _data["buyerIdentifier"] !== undefined ? _data["buyerIdentifier"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>null;
            this.titleEng = _data["titleEng"] !== undefined ? _data["titleEng"] : <any>null;
            this.titlePl = _data["titlePl"] !== undefined ? _data["titlePl"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentsAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentsAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["offerTitle"] = this.offerTitle !== undefined ? this.offerTitle : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString(true) : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString(true) : <any>null;
        data["priceInfo"] = this.priceInfo ? this.priceInfo.toJSON() : <any>null;
        data["paymentStatus"] = this.paymentStatus !== undefined ? this.paymentStatus : <any>null;
        data["isInvoiceCreated"] = this.isInvoiceCreated !== undefined ? this.isInvoiceCreated : <any>null;
        data["gameInstanceId"] = this.gameInstanceId !== undefined ? this.gameInstanceId : <any>null;
        data["gameInstanceTitle"] = this.gameInstanceTitle !== undefined ? this.gameInstanceTitle : <any>null;
        data["invoiceCode"] = this.invoiceCode !== undefined ? this.invoiceCode : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["vatNumber"] = this.vatNumber !== undefined ? this.vatNumber : <any>null;
        data["buyerIdentifier"] = this.buyerIdentifier !== undefined ? this.buyerIdentifier : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["titleEng"] = this.titleEng !== undefined ? this.titleEng : <any>null;
        data["titlePl"] = this.titlePl !== undefined ? this.titlePl : <any>null;
        return data; 
    }
}

export interface IPaymentsAdminDto {
    id: string;
    userId?: string | null;
    orderNumber?: string | null;
    offerTitle?: string | null;
    createdAt?: moment.Moment | null;
    updatedAt?: moment.Moment | null;
    priceInfo?: PriceInfo | null;
    paymentStatus: PaymentStatus;
    isInvoiceCreated: boolean;
    gameInstanceId: string;
    gameInstanceTitle?: string | null;
    invoiceCode?: string | null;
    companyName?: string | null;
    vatNumber?: string | null;
    buyerIdentifier?: string | null;
    email?: string | null;
    address?: AddressDto | null;
    titleEng?: string | null;
    titlePl?: string | null;
}

export class AddressDto implements IAddressDto {
    countryCode!: string;
    city?: string | null;
    postCode?: string | null;
    street?: string | null;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : <any>null;
            this.street = _data["street"] !== undefined ? _data["street"] : <any>null;
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["postCode"] = this.postCode !== undefined ? this.postCode : <any>null;
        data["street"] = this.street !== undefined ? this.street : <any>null;
        return data; 
    }
}

export interface IAddressDto {
    countryCode: string;
    city?: string | null;
    postCode?: string | null;
    street?: string | null;
}

export class PayInputModel implements IPayInputModel {
    gameInstanceId!: string;
    orderNumber?: string | null;

    constructor(data?: IPayInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameInstanceId = _data["gameInstanceId"] !== undefined ? _data["gameInstanceId"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
        }
    }

    static fromJS(data: any): PayInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new PayInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameInstanceId"] = this.gameInstanceId !== undefined ? this.gameInstanceId : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        return data; 
    }
}

export interface IPayInputModel {
    gameInstanceId: string;
    orderNumber?: string | null;
}

export class RecipientDataInputModel implements IRecipientDataInputModel {
    orderNumber!: string;
    currency!: Currency;
    discountCode?: string | null;
    companyName?: string | null;
    vatNumber?: string | null;
    address!: Address;

    constructor(data?: IRecipientDataInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new Address();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.discountCode = _data["discountCode"] !== undefined ? _data["discountCode"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.vatNumber = _data["vatNumber"] !== undefined ? _data["vatNumber"] : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : new Address();
        }
    }

    static fromJS(data: any): RecipientDataInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecipientDataInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["discountCode"] = this.discountCode !== undefined ? this.discountCode : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["vatNumber"] = this.vatNumber !== undefined ? this.vatNumber : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        return data; 
    }
}

export interface IRecipientDataInputModel {
    orderNumber: string;
    currency: Currency;
    discountCode?: string | null;
    companyName?: string | null;
    vatNumber?: string | null;
    address: Address;
}

export class GameInstanceRecipientDataInputModel extends RecipientDataInputModel implements IGameInstanceRecipientDataInputModel {
    gameInstanceId!: string;

    constructor(data?: IGameInstanceRecipientDataInputModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.gameInstanceId = _data["gameInstanceId"] !== undefined ? _data["gameInstanceId"] : <any>null;
        }
    }

    static fromJS(data: any): GameInstanceRecipientDataInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new GameInstanceRecipientDataInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameInstanceId"] = this.gameInstanceId !== undefined ? this.gameInstanceId : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IGameInstanceRecipientDataInputModel extends IRecipientDataInputModel {
    gameInstanceId: string;
}

export class Address implements IAddress {
    countryCode!: string;
    city?: string | null;
    postCode?: string | null;
    street?: string | null;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : <any>null;
            this.street = _data["street"] !== undefined ? _data["street"] : <any>null;
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["postCode"] = this.postCode !== undefined ? this.postCode : <any>null;
        data["street"] = this.street !== undefined ? this.street : <any>null;
        return data; 
    }
}

export interface IAddress {
    countryCode: string;
    city?: string | null;
    postCode?: string | null;
    street?: string | null;
}

export class CreateEmptyPurchaseDto implements ICreateEmptyPurchaseDto {
    purchaseId!: string;
    purchaseNumber?: string | null;

    constructor(data?: ICreateEmptyPurchaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseId = _data["purchaseId"] !== undefined ? _data["purchaseId"] : <any>null;
            this.purchaseNumber = _data["purchaseNumber"] !== undefined ? _data["purchaseNumber"] : <any>null;
        }
    }

    static fromJS(data: any): CreateEmptyPurchaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmptyPurchaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseId"] = this.purchaseId !== undefined ? this.purchaseId : <any>null;
        data["purchaseNumber"] = this.purchaseNumber !== undefined ? this.purchaseNumber : <any>null;
        return data; 
    }
}

export interface ICreateEmptyPurchaseDto {
    purchaseId: string;
    purchaseNumber?: string | null;
}

export class CreateEmptyPurchaseInputModel implements ICreateEmptyPurchaseInputModel {
    gameInstanceId!: string;

    constructor(data?: ICreateEmptyPurchaseInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameInstanceId = _data["gameInstanceId"] !== undefined ? _data["gameInstanceId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateEmptyPurchaseInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmptyPurchaseInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameInstanceId"] = this.gameInstanceId !== undefined ? this.gameInstanceId : <any>null;
        return data; 
    }
}

export interface ICreateEmptyPurchaseInputModel {
    gameInstanceId: string;
}

export class PayUUpdateNotification implements IPayUUpdateNotification {
    order?: PayUOrderExtended | null;

    constructor(data?: IPayUUpdateNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? PayUOrderExtended.fromJS(_data["order"]) : <any>null;
        }
    }

    static fromJS(data: any): PayUUpdateNotification {
        data = typeof data === 'object' ? data : {};
        let result = new PayUUpdateNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>null;
        return data; 
    }
}

export interface IPayUUpdateNotification {
    order?: PayUOrderExtended | null;
}

export class PayUOrder implements IPayUOrder {
    /** Identyfikator zamówienia w systemie sprzedawcy */
    extOrderId?: string | null;
    /** Adres pod który będą przesyłane powiadomienia */
    notifyUrl?: string | null;
    /** Adres IP płacącego, np. "123.123.123.123" (uwaga: adres "0.0.0.0" nie jest dopuszczalny). */
    customerIp?: string | null;
    /** Identyfikator punktu płatności na którym zostanie wykonana płatność	 */
    merchantPosId?: string | null;
    /** Czas w trakcie którego możliwe jest dokończenie zamówienia w sekundach. */
    validityTime?: number | null;
    /** Opis zamówienia (wymagany) */
    description?: string | null;
    /** Dodatkowy opis zamówienia. (niewymagany) */
    additionalDescription?: string | null;
    /** Waluta zamówienia w standardzie ISO 4217, np. "PLN". */
    currencyCode?: string | null;
    /** Całkowity koszt zamówienia w groszach (np. 1000 to 10,00 EUR). Dotyczy również walut bez groszy (tj. 1000 to 10 HUF). */
    totalAmount?: string | null;
    /** Adres na jaki będzie przekierowany płatnik po zakończeniu procesu płatności */
    continueUrl?: string | null;
    /** Sekcja przechowująca dane kupującego. */
    buyer?: PayUBuyer | null;
    /** Sekcja zawiera dane o produktach. */
    products?: PayUOrderProduct[] | null;
    settings?: PayUOrderSettings | null;

    constructor(data?: IPayUOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extOrderId = _data["extOrderId"] !== undefined ? _data["extOrderId"] : <any>null;
            this.notifyUrl = _data["notifyUrl"] !== undefined ? _data["notifyUrl"] : <any>null;
            this.customerIp = _data["customerIp"] !== undefined ? _data["customerIp"] : <any>null;
            this.merchantPosId = _data["merchantPosId"] !== undefined ? _data["merchantPosId"] : <any>null;
            this.validityTime = _data["validityTime"] !== undefined ? _data["validityTime"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.additionalDescription = _data["additionalDescription"] !== undefined ? _data["additionalDescription"] : <any>null;
            this.currencyCode = _data["currencyCode"] !== undefined ? _data["currencyCode"] : <any>null;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : <any>null;
            this.continueUrl = _data["continueUrl"] !== undefined ? _data["continueUrl"] : <any>null;
            this.buyer = _data["buyer"] ? PayUBuyer.fromJS(_data["buyer"]) : <any>null;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(PayUOrderProduct.fromJS(item));
            }
            this.settings = _data["settings"] ? PayUOrderSettings.fromJS(_data["settings"]) : <any>null;
        }
    }

    static fromJS(data: any): PayUOrder {
        data = typeof data === 'object' ? data : {};
        let result = new PayUOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extOrderId"] = this.extOrderId !== undefined ? this.extOrderId : <any>null;
        data["notifyUrl"] = this.notifyUrl !== undefined ? this.notifyUrl : <any>null;
        data["customerIp"] = this.customerIp !== undefined ? this.customerIp : <any>null;
        data["merchantPosId"] = this.merchantPosId !== undefined ? this.merchantPosId : <any>null;
        data["validityTime"] = this.validityTime !== undefined ? this.validityTime : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["additionalDescription"] = this.additionalDescription !== undefined ? this.additionalDescription : <any>null;
        data["currencyCode"] = this.currencyCode !== undefined ? this.currencyCode : <any>null;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : <any>null;
        data["continueUrl"] = this.continueUrl !== undefined ? this.continueUrl : <any>null;
        data["buyer"] = this.buyer ? this.buyer.toJSON() : <any>null;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["settings"] = this.settings ? this.settings.toJSON() : <any>null;
        return data; 
    }
}

export interface IPayUOrder {
    /** Identyfikator zamówienia w systemie sprzedawcy */
    extOrderId?: string | null;
    /** Adres pod który będą przesyłane powiadomienia */
    notifyUrl?: string | null;
    /** Adres IP płacącego, np. "123.123.123.123" (uwaga: adres "0.0.0.0" nie jest dopuszczalny). */
    customerIp?: string | null;
    /** Identyfikator punktu płatności na którym zostanie wykonana płatność	 */
    merchantPosId?: string | null;
    /** Czas w trakcie którego możliwe jest dokończenie zamówienia w sekundach. */
    validityTime?: number | null;
    /** Opis zamówienia (wymagany) */
    description?: string | null;
    /** Dodatkowy opis zamówienia. (niewymagany) */
    additionalDescription?: string | null;
    /** Waluta zamówienia w standardzie ISO 4217, np. "PLN". */
    currencyCode?: string | null;
    /** Całkowity koszt zamówienia w groszach (np. 1000 to 10,00 EUR). Dotyczy również walut bez groszy (tj. 1000 to 10 HUF). */
    totalAmount?: string | null;
    /** Adres na jaki będzie przekierowany płatnik po zakończeniu procesu płatności */
    continueUrl?: string | null;
    /** Sekcja przechowująca dane kupującego. */
    buyer?: PayUBuyer | null;
    /** Sekcja zawiera dane o produktach. */
    products?: PayUOrderProduct[] | null;
    settings?: PayUOrderSettings | null;
}

export class PayUOrderExtended extends PayUOrder implements IPayUOrderExtended {
    orderId?: string | null;
    status?: string | null;
    orderCreateDate?: moment.Moment | null;

    constructor(data?: IPayUOrderExtended) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.orderCreateDate = _data["orderCreateDate"] ? moment.parseZone(_data["orderCreateDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): PayUOrderExtended {
        data = typeof data === 'object' ? data : {};
        let result = new PayUOrderExtended();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId !== undefined ? this.orderId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["orderCreateDate"] = this.orderCreateDate ? this.orderCreateDate.toISOString(true) : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IPayUOrderExtended extends IPayUOrder {
    orderId?: string | null;
    status?: string | null;
    orderCreateDate?: moment.Moment | null;
}

export class PayUBuyer implements IPayUBuyer {
    email?: string | null;
    /** Kod języka zgodnie z ISO-639-1 - określa język strony płatniczej oraz język wiadomości e-mail wysyłanych przez PayU do płatnika - https://developers.payu.com/pl/overview.html#languages */
    language?: string | null;

    constructor(data?: IPayUBuyer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): PayUBuyer {
        data = typeof data === 'object' ? data : {};
        let result = new PayUBuyer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        return data; 
    }
}

export interface IPayUBuyer {
    email?: string | null;
    /** Kod języka zgodnie z ISO-639-1 - określa język strony płatniczej oraz język wiadomości e-mail wysyłanych przez PayU do płatnika - https://developers.payu.com/pl/overview.html#languages */
    language?: string | null;
}

export class PayUOrderProduct implements IPayUOrderProduct {
    name?: string | null;
    unitPrice?: string | null;
    quantity?: string | null;

    constructor(data?: IPayUOrderProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
        }
    }

    static fromJS(data: any): PayUOrderProduct {
        data = typeof data === 'object' ? data : {};
        let result = new PayUOrderProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        return data; 
    }
}

export interface IPayUOrderProduct {
    name?: string | null;
    unitPrice?: string | null;
    quantity?: string | null;
}

export class PayUOrderSettings implements IPayUOrderSettings {
    invoiceDisabled!: boolean;

    constructor(data?: IPayUOrderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceDisabled = _data["invoiceDisabled"] !== undefined ? _data["invoiceDisabled"] : <any>null;
        }
    }

    static fromJS(data: any): PayUOrderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new PayUOrderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceDisabled"] = this.invoiceDisabled !== undefined ? this.invoiceDisabled : <any>null;
        return data; 
    }
}

export interface IPayUOrderSettings {
    invoiceDisabled: boolean;
}

export class GetInitialOrderDataDto implements IGetInitialOrderDataDto {
    gameInstanceId!: string;
    priceInfo!: PriceInfo;
    invoiceRecipient!: InvoiceRecipientDto;
    newValidUntil?: moment.Moment | null;

    constructor(data?: IGetInitialOrderDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.priceInfo = new PriceInfo();
            this.invoiceRecipient = new InvoiceRecipientDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameInstanceId = _data["gameInstanceId"] !== undefined ? _data["gameInstanceId"] : <any>null;
            this.priceInfo = _data["priceInfo"] ? PriceInfo.fromJS(_data["priceInfo"]) : new PriceInfo();
            this.invoiceRecipient = _data["invoiceRecipient"] ? InvoiceRecipientDto.fromJS(_data["invoiceRecipient"]) : new InvoiceRecipientDto();
            this.newValidUntil = _data["newValidUntil"] ? moment.parseZone(_data["newValidUntil"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetInitialOrderDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInitialOrderDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameInstanceId"] = this.gameInstanceId !== undefined ? this.gameInstanceId : <any>null;
        data["priceInfo"] = this.priceInfo ? this.priceInfo.toJSON() : <any>null;
        data["invoiceRecipient"] = this.invoiceRecipient ? this.invoiceRecipient.toJSON() : <any>null;
        data["newValidUntil"] = this.newValidUntil ? this.newValidUntil.toISOString(true) : <any>null;
        return data; 
    }
}

export interface IGetInitialOrderDataDto {
    gameInstanceId: string;
    priceInfo: PriceInfo;
    invoiceRecipient: InvoiceRecipientDto;
    newValidUntil?: moment.Moment | null;
}

export class InvoiceRecipientDto implements IInvoiceRecipientDto {
    companyName!: string;
    vatNumber?: string | null;
    address!: AddressDto;

    constructor(data?: IInvoiceRecipientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new AddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.vatNumber = _data["vatNumber"] !== undefined ? _data["vatNumber"] : <any>null;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : new AddressDto();
        }
    }

    static fromJS(data: any): InvoiceRecipientDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceRecipientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["vatNumber"] = this.vatNumber !== undefined ? this.vatNumber : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        return data; 
    }
}

export interface IInvoiceRecipientDto {
    companyName: string;
    vatNumber?: string | null;
    address: AddressDto;
}

export class VerifyDiscountResultDto implements IVerifyDiscountResultDto {
    code!: string;
    value!: number;
    priceInfo?: PriceInfo | null;

    constructor(data?: IVerifyDiscountResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.priceInfo = _data["priceInfo"] ? PriceInfo.fromJS(_data["priceInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): VerifyDiscountResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyDiscountResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["priceInfo"] = this.priceInfo ? this.priceInfo.toJSON() : <any>null;
        return data; 
    }
}

export interface IVerifyDiscountResultDto {
    code: string;
    value: number;
    priceInfo?: PriceInfo | null;
}

export class GetPriceInfoDto implements IGetPriceInfoDto {
    priceInfo?: PriceInfo | null;

    constructor(data?: IGetPriceInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priceInfo = _data["priceInfo"] ? PriceInfo.fromJS(_data["priceInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): GetPriceInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPriceInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceInfo"] = this.priceInfo ? this.priceInfo.toJSON() : <any>null;
        return data; 
    }
}

export interface IGetPriceInfoDto {
    priceInfo?: PriceInfo | null;
}

export class OrderListItemDto implements IOrderListItemDto {
    id!: string;
    orderNumber?: string | null;
    offerTitle?: string | null;
    createdAt?: moment.Moment | null;
    updatedAt?: moment.Moment | null;
    priceInfo?: PriceInfo | null;
    status!: PaymentStatus;
    isInvoiceCreated!: boolean;
    gameInstanceId!: string;
    gameInstanceTitle?: string | null;
    gameInstanceDeleted!: boolean;

    constructor(data?: IOrderListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.offerTitle = _data["offerTitle"] !== undefined ? _data["offerTitle"] : <any>null;
            this.createdAt = _data["createdAt"] ? moment.parseZone(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? moment.parseZone(_data["updatedAt"].toString()) : <any>null;
            this.priceInfo = _data["priceInfo"] ? PriceInfo.fromJS(_data["priceInfo"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.isInvoiceCreated = _data["isInvoiceCreated"] !== undefined ? _data["isInvoiceCreated"] : <any>null;
            this.gameInstanceId = _data["gameInstanceId"] !== undefined ? _data["gameInstanceId"] : <any>null;
            this.gameInstanceTitle = _data["gameInstanceTitle"] !== undefined ? _data["gameInstanceTitle"] : <any>null;
            this.gameInstanceDeleted = _data["gameInstanceDeleted"] !== undefined ? _data["gameInstanceDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): OrderListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["offerTitle"] = this.offerTitle !== undefined ? this.offerTitle : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString(true) : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString(true) : <any>null;
        data["priceInfo"] = this.priceInfo ? this.priceInfo.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["isInvoiceCreated"] = this.isInvoiceCreated !== undefined ? this.isInvoiceCreated : <any>null;
        data["gameInstanceId"] = this.gameInstanceId !== undefined ? this.gameInstanceId : <any>null;
        data["gameInstanceTitle"] = this.gameInstanceTitle !== undefined ? this.gameInstanceTitle : <any>null;
        data["gameInstanceDeleted"] = this.gameInstanceDeleted !== undefined ? this.gameInstanceDeleted : <any>null;
        return data; 
    }
}

export interface IOrderListItemDto {
    id: string;
    orderNumber?: string | null;
    offerTitle?: string | null;
    createdAt?: moment.Moment | null;
    updatedAt?: moment.Moment | null;
    priceInfo?: PriceInfo | null;
    status: PaymentStatus;
    isInvoiceCreated: boolean;
    gameInstanceId: string;
    gameInstanceTitle?: string | null;
    gameInstanceDeleted: boolean;
}

export class OrderDetailsDto implements IOrderDetailsDto {
    id!: string;
    orderNumber?: string | null;
    offerTitle?: string | null;
    createdAt?: moment.Moment | null;
    updatedAt?: moment.Moment | null;
    priceInfo?: PriceInfo | null;
    status!: PaymentStatus;
    isInvoiceCreated!: boolean;
    gameInstanceId!: string;
    gameInstanceTitle?: string | null;
    companyName?: string | null;
    vatNumber?: string | null;
    address?: AddressDto | null;
    gameInstanceDeleted!: boolean;
    titleEng?: string | null;
    titlePl?: string | null;

    constructor(data?: IOrderDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.offerTitle = _data["offerTitle"] !== undefined ? _data["offerTitle"] : <any>null;
            this.createdAt = _data["createdAt"] ? moment.parseZone(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? moment.parseZone(_data["updatedAt"].toString()) : <any>null;
            this.priceInfo = _data["priceInfo"] ? PriceInfo.fromJS(_data["priceInfo"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.isInvoiceCreated = _data["isInvoiceCreated"] !== undefined ? _data["isInvoiceCreated"] : <any>null;
            this.gameInstanceId = _data["gameInstanceId"] !== undefined ? _data["gameInstanceId"] : <any>null;
            this.gameInstanceTitle = _data["gameInstanceTitle"] !== undefined ? _data["gameInstanceTitle"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.vatNumber = _data["vatNumber"] !== undefined ? _data["vatNumber"] : <any>null;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>null;
            this.gameInstanceDeleted = _data["gameInstanceDeleted"] !== undefined ? _data["gameInstanceDeleted"] : <any>null;
            this.titleEng = _data["titleEng"] !== undefined ? _data["titleEng"] : <any>null;
            this.titlePl = _data["titlePl"] !== undefined ? _data["titlePl"] : <any>null;
        }
    }

    static fromJS(data: any): OrderDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["offerTitle"] = this.offerTitle !== undefined ? this.offerTitle : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString(true) : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString(true) : <any>null;
        data["priceInfo"] = this.priceInfo ? this.priceInfo.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["isInvoiceCreated"] = this.isInvoiceCreated !== undefined ? this.isInvoiceCreated : <any>null;
        data["gameInstanceId"] = this.gameInstanceId !== undefined ? this.gameInstanceId : <any>null;
        data["gameInstanceTitle"] = this.gameInstanceTitle !== undefined ? this.gameInstanceTitle : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["vatNumber"] = this.vatNumber !== undefined ? this.vatNumber : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["gameInstanceDeleted"] = this.gameInstanceDeleted !== undefined ? this.gameInstanceDeleted : <any>null;
        data["titleEng"] = this.titleEng !== undefined ? this.titleEng : <any>null;
        data["titlePl"] = this.titlePl !== undefined ? this.titlePl : <any>null;
        return data; 
    }
}

export interface IOrderDetailsDto {
    id: string;
    orderNumber?: string | null;
    offerTitle?: string | null;
    createdAt?: moment.Moment | null;
    updatedAt?: moment.Moment | null;
    priceInfo?: PriceInfo | null;
    status: PaymentStatus;
    isInvoiceCreated: boolean;
    gameInstanceId: string;
    gameInstanceTitle?: string | null;
    companyName?: string | null;
    vatNumber?: string | null;
    address?: AddressDto | null;
    gameInstanceDeleted: boolean;
    titleEng?: string | null;
    titlePl?: string | null;
}

export class InvoiceDto implements IInvoiceDto {
    value?: string | null;
    fileName?: string | null;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data; 
    }
}

export interface IInvoiceDto {
    value?: string | null;
    fileName?: string | null;
}

export class ProfessionDto implements IProfessionDto {
    id!: string;
    title?: string | null;
    displayTitle?: string | null;
    isGlobal!: boolean;
    userId?: string | null;
    questions?: QuestionDto[] | null;

    constructor(data?: IProfessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.displayTitle = _data["displayTitle"] !== undefined ? _data["displayTitle"] : <any>null;
            this.isGlobal = _data["isGlobal"] !== undefined ? _data["isGlobal"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(QuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["displayTitle"] = this.displayTitle !== undefined ? this.displayTitle : <any>null;
        data["isGlobal"] = this.isGlobal !== undefined ? this.isGlobal : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProfessionDto {
    id: string;
    title?: string | null;
    displayTitle?: string | null;
    isGlobal: boolean;
    userId?: string | null;
    questions?: QuestionDto[] | null;
}

export class QuestionDto implements IQuestionDto {
    id!: string;
    questionText?: string | null;
    questionAnswers?: QuestionAnswerDto[] | null;

    constructor(data?: IQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.questionText = _data["questionText"] !== undefined ? _data["questionText"] : <any>null;
            if (Array.isArray(_data["questionAnswers"])) {
                this.questionAnswers = [] as any;
                for (let item of _data["questionAnswers"])
                    this.questionAnswers!.push(QuestionAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["questionText"] = this.questionText !== undefined ? this.questionText : <any>null;
        if (Array.isArray(this.questionAnswers)) {
            data["questionAnswers"] = [];
            for (let item of this.questionAnswers)
                data["questionAnswers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IQuestionDto {
    id: string;
    questionText?: string | null;
    questionAnswers?: QuestionAnswerDto[] | null;
}

export class QuestionAnswerDto implements IQuestionAnswerDto {
    id!: string;
    answerText?: string | null;
    isCorrect!: boolean;

    constructor(data?: IQuestionAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.answerText = _data["answerText"] !== undefined ? _data["answerText"] : <any>null;
            this.isCorrect = _data["isCorrect"] !== undefined ? _data["isCorrect"] : <any>null;
        }
    }

    static fromJS(data: any): QuestionAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["answerText"] = this.answerText !== undefined ? this.answerText : <any>null;
        data["isCorrect"] = this.isCorrect !== undefined ? this.isCorrect : <any>null;
        return data; 
    }
}

export interface IQuestionAnswerDto {
    id: string;
    answerText?: string | null;
    isCorrect: boolean;
}

export class ProfessionCreateInputModel implements IProfessionCreateInputModel {
    name!: string;
    displayName!: string;
    copiedProfessionId?: string | null;

    constructor(data?: IProfessionCreateInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.copiedProfessionId = _data["copiedProfessionId"] !== undefined ? _data["copiedProfessionId"] : <any>null;
        }
    }

    static fromJS(data: any): ProfessionCreateInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionCreateInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["copiedProfessionId"] = this.copiedProfessionId !== undefined ? this.copiedProfessionId : <any>null;
        return data; 
    }
}

export interface IProfessionCreateInputModel {
    name: string;
    displayName: string;
    copiedProfessionId?: string | null;
}

export class ProfessionUpdateInputModel implements IProfessionUpdateInputModel {
    professionId!: string;
    name!: string;
    displayName!: string;

    constructor(data?: IProfessionUpdateInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"] !== undefined ? _data["professionId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
        }
    }

    static fromJS(data: any): ProfessionUpdateInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionUpdateInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId !== undefined ? this.professionId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        return data; 
    }
}

export interface IProfessionUpdateInputModel {
    professionId: string;
    name: string;
    displayName: string;
}

export class ProfessionDeleteInputModel implements IProfessionDeleteInputModel {
    professionId!: string;

    constructor(data?: IProfessionDeleteInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"] !== undefined ? _data["professionId"] : <any>null;
        }
    }

    static fromJS(data: any): ProfessionDeleteInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionDeleteInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId !== undefined ? this.professionId : <any>null;
        return data; 
    }
}

export interface IProfessionDeleteInputModel {
    professionId: string;
}

export class QuestionCreateInputModel implements IQuestionCreateInputModel {
    professionId!: string;
    questionText!: string;
    answers!: QuestionAnswerInputModel[];

    constructor(data?: IQuestionCreateInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"] !== undefined ? _data["professionId"] : <any>null;
            this.questionText = _data["questionText"] !== undefined ? _data["questionText"] : <any>null;
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(QuestionAnswerInputModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionCreateInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionCreateInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId !== undefined ? this.professionId : <any>null;
        data["questionText"] = this.questionText !== undefined ? this.questionText : <any>null;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IQuestionCreateInputModel {
    professionId: string;
    questionText: string;
    answers: QuestionAnswerInputModel[];
}

export class QuestionAnswerInputModel implements IQuestionAnswerInputModel {
    answerText!: string;
    isCorrect!: boolean;

    constructor(data?: IQuestionAnswerInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answerText = _data["answerText"] !== undefined ? _data["answerText"] : <any>null;
            this.isCorrect = _data["isCorrect"] !== undefined ? _data["isCorrect"] : <any>null;
        }
    }

    static fromJS(data: any): QuestionAnswerInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswerInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerText"] = this.answerText !== undefined ? this.answerText : <any>null;
        data["isCorrect"] = this.isCorrect !== undefined ? this.isCorrect : <any>null;
        return data; 
    }
}

export interface IQuestionAnswerInputModel {
    answerText: string;
    isCorrect: boolean;
}

export class QuestionUpdateInputModel implements IQuestionUpdateInputModel {
    questionId!: string;
    questionText!: string;
    answers!: QuestionAnswerInputModel[];

    constructor(data?: IQuestionUpdateInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"] !== undefined ? _data["questionId"] : <any>null;
            this.questionText = _data["questionText"] !== undefined ? _data["questionText"] : <any>null;
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(QuestionAnswerInputModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionUpdateInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionUpdateInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId !== undefined ? this.questionId : <any>null;
        data["questionText"] = this.questionText !== undefined ? this.questionText : <any>null;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IQuestionUpdateInputModel {
    questionId: string;
    questionText: string;
    answers: QuestionAnswerInputModel[];
}

export class QuestionDeleteInputModel implements IQuestionDeleteInputModel {
    questionId!: string;

    constructor(data?: IQuestionDeleteInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"] !== undefined ? _data["questionId"] : <any>null;
        }
    }

    static fromJS(data: any): QuestionDeleteInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionDeleteInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId !== undefined ? this.questionId : <any>null;
        return data; 
    }
}

export interface IQuestionDeleteInputModel {
    questionId: string;
}

export class ConfigurationDto implements IConfigurationDto {
    version?: string | null;
    googleAnalyticsId?: string | null;
    facebookPixelId?: string | null;
    environmentName!: Environment;
    ppUrl?: string | null;

    constructor(data?: IConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.googleAnalyticsId = _data["googleAnalyticsId"] !== undefined ? _data["googleAnalyticsId"] : <any>null;
            this.facebookPixelId = _data["facebookPixelId"] !== undefined ? _data["facebookPixelId"] : <any>null;
            this.environmentName = _data["environmentName"] !== undefined ? _data["environmentName"] : <any>null;
            this.ppUrl = _data["ppUrl"] !== undefined ? _data["ppUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["googleAnalyticsId"] = this.googleAnalyticsId !== undefined ? this.googleAnalyticsId : <any>null;
        data["facebookPixelId"] = this.facebookPixelId !== undefined ? this.facebookPixelId : <any>null;
        data["environmentName"] = this.environmentName !== undefined ? this.environmentName : <any>null;
        data["ppUrl"] = this.ppUrl !== undefined ? this.ppUrl : <any>null;
        return data; 
    }
}

export interface IConfigurationDto {
    version?: string | null;
    googleAnalyticsId?: string | null;
    facebookPixelId?: string | null;
    environmentName: Environment;
    ppUrl?: string | null;
}

export enum Environment {
    Development = "Development",
    Production = "Production",
}

export class InstanceGlobalStatisticsDto implements IInstanceGlobalStatisticsDto {
    gameInstanceTitle?: string | null;
    mails!: number;
    games!: number;
    finishedGames?: string | null;
    playedMoreThanOnce?: string | null;
    percentOfGoodAnswers?: string | null;

    constructor(data?: IInstanceGlobalStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameInstanceTitle = _data["gameInstanceTitle"] !== undefined ? _data["gameInstanceTitle"] : <any>null;
            this.mails = _data["mails"] !== undefined ? _data["mails"] : <any>null;
            this.games = _data["games"] !== undefined ? _data["games"] : <any>null;
            this.finishedGames = _data["finishedGames"] !== undefined ? _data["finishedGames"] : <any>null;
            this.playedMoreThanOnce = _data["playedMoreThanOnce"] !== undefined ? _data["playedMoreThanOnce"] : <any>null;
            this.percentOfGoodAnswers = _data["percentOfGoodAnswers"] !== undefined ? _data["percentOfGoodAnswers"] : <any>null;
        }
    }

    static fromJS(data: any): InstanceGlobalStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstanceGlobalStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameInstanceTitle"] = this.gameInstanceTitle !== undefined ? this.gameInstanceTitle : <any>null;
        data["mails"] = this.mails !== undefined ? this.mails : <any>null;
        data["games"] = this.games !== undefined ? this.games : <any>null;
        data["finishedGames"] = this.finishedGames !== undefined ? this.finishedGames : <any>null;
        data["playedMoreThanOnce"] = this.playedMoreThanOnce !== undefined ? this.playedMoreThanOnce : <any>null;
        data["percentOfGoodAnswers"] = this.percentOfGoodAnswers !== undefined ? this.percentOfGoodAnswers : <any>null;
        return data; 
    }
}

export interface IInstanceGlobalStatisticsDto {
    gameInstanceTitle?: string | null;
    mails: number;
    games: number;
    finishedGames?: string | null;
    playedMoreThanOnce?: string | null;
    percentOfGoodAnswers?: string | null;
}

export class InstanceGlobalStatisticsForPlayerDto implements IInstanceGlobalStatisticsForPlayerDto {
    selectedProfessions!: number;
    games!: number;
    finishedGames?: string | null;
    totalPlayTime!: moment.Duration;
    percentOfGoodAnswers?: string | null;

    constructor(data?: IInstanceGlobalStatisticsForPlayerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectedProfessions = _data["selectedProfessions"] !== undefined ? _data["selectedProfessions"] : <any>null;
            this.games = _data["games"] !== undefined ? _data["games"] : <any>null;
            this.finishedGames = _data["finishedGames"] !== undefined ? _data["finishedGames"] : <any>null;
            this.totalPlayTime = _data["totalPlayTime"] ? moment.duration(_data["totalPlayTime"].toString()) : <any>null;
            this.percentOfGoodAnswers = _data["percentOfGoodAnswers"] !== undefined ? _data["percentOfGoodAnswers"] : <any>null;
        }
    }

    static fromJS(data: any): InstanceGlobalStatisticsForPlayerDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstanceGlobalStatisticsForPlayerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedProfessions"] = this.selectedProfessions !== undefined ? this.selectedProfessions : <any>null;
        data["games"] = this.games !== undefined ? this.games : <any>null;
        data["finishedGames"] = this.finishedGames !== undefined ? this.finishedGames : <any>null;
        data["totalPlayTime"] = this.totalPlayTime ? this.totalPlayTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["percentOfGoodAnswers"] = this.percentOfGoodAnswers !== undefined ? this.percentOfGoodAnswers : <any>null;
        return data; 
    }
}

export interface IInstanceGlobalStatisticsForPlayerDto {
    selectedProfessions: number;
    games: number;
    finishedGames?: string | null;
    totalPlayTime: moment.Duration;
    percentOfGoodAnswers?: string | null;
}

export class InstancePlayersStatisticsDto implements IInstancePlayersStatisticsDto {
    email?: string | null;
    playedProfession?: string[] | null;
    isFavorite!: boolean;
    rating!: number;
    startedGames!: number;
    finishedGames!: number;
    averageTimeForGame!: moment.Duration;
    totalTimeForGames!: moment.Duration;
    percentOfGoodAnswers?: string | null;
    addedCV!: boolean;

    constructor(data?: IInstancePlayersStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            if (Array.isArray(_data["playedProfession"])) {
                this.playedProfession = [] as any;
                for (let item of _data["playedProfession"])
                    this.playedProfession!.push(item);
            }
            this.isFavorite = _data["isFavorite"] !== undefined ? _data["isFavorite"] : <any>null;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : <any>null;
            this.startedGames = _data["startedGames"] !== undefined ? _data["startedGames"] : <any>null;
            this.finishedGames = _data["finishedGames"] !== undefined ? _data["finishedGames"] : <any>null;
            this.averageTimeForGame = _data["averageTimeForGame"] ? moment.duration(_data["averageTimeForGame"].toString()) : <any>null;
            this.totalTimeForGames = _data["totalTimeForGames"] ? moment.duration(_data["totalTimeForGames"].toString()) : <any>null;
            this.percentOfGoodAnswers = _data["percentOfGoodAnswers"] !== undefined ? _data["percentOfGoodAnswers"] : <any>null;
            this.addedCV = _data["addedCV"] !== undefined ? _data["addedCV"] : <any>null;
        }
    }

    static fromJS(data: any): InstancePlayersStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstancePlayersStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        if (Array.isArray(this.playedProfession)) {
            data["playedProfession"] = [];
            for (let item of this.playedProfession)
                data["playedProfession"].push(item);
        }
        data["isFavorite"] = this.isFavorite !== undefined ? this.isFavorite : <any>null;
        data["rating"] = this.rating !== undefined ? this.rating : <any>null;
        data["startedGames"] = this.startedGames !== undefined ? this.startedGames : <any>null;
        data["finishedGames"] = this.finishedGames !== undefined ? this.finishedGames : <any>null;
        data["averageTimeForGame"] = this.averageTimeForGame ? this.averageTimeForGame.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["totalTimeForGames"] = this.totalTimeForGames ? this.totalTimeForGames.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["percentOfGoodAnswers"] = this.percentOfGoodAnswers !== undefined ? this.percentOfGoodAnswers : <any>null;
        data["addedCV"] = this.addedCV !== undefined ? this.addedCV : <any>null;
        return data; 
    }
}

export interface IInstancePlayersStatisticsDto {
    email?: string | null;
    playedProfession?: string[] | null;
    isFavorite: boolean;
    rating: number;
    startedGames: number;
    finishedGames: number;
    averageTimeForGame: moment.Duration;
    totalTimeForGames: moment.Duration;
    percentOfGoodAnswers?: string | null;
    addedCV: boolean;
}

export class PlayerInstanceDetailsDto implements IPlayerInstanceDetailsDto {
    playerInstanceId!: string;
    cv?: string | null;
    email?: string | null;

    constructor(data?: IPlayerInstanceDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerInstanceId = _data["playerInstanceId"] !== undefined ? _data["playerInstanceId"] : <any>null;
            this.cv = _data["cv"] !== undefined ? _data["cv"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): PlayerInstanceDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerInstanceDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerInstanceId"] = this.playerInstanceId !== undefined ? this.playerInstanceId : <any>null;
        data["cv"] = this.cv !== undefined ? this.cv : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data; 
    }
}

export interface IPlayerInstanceDetailsDto {
    playerInstanceId: string;
    cv?: string | null;
    email?: string | null;
}

export class InstanceGameStatisticsDto implements IInstanceGameStatisticsDto {
    id!: string;
    gameInstanceTitle?: string | null;
    email?: string | null;
    profession?: string | null;
    startingTime?: moment.Moment | null;
    playingTime?: moment.Duration | null;
    totalAnswers!: number;
    correctAnswers!: number;
    score!: number;

    constructor(data?: IInstanceGameStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.gameInstanceTitle = _data["gameInstanceTitle"] !== undefined ? _data["gameInstanceTitle"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.profession = _data["profession"] !== undefined ? _data["profession"] : <any>null;
            this.startingTime = _data["startingTime"] ? moment.parseZone(_data["startingTime"].toString()) : <any>null;
            this.playingTime = _data["playingTime"] ? moment.duration(_data["playingTime"].toString()) : <any>null;
            this.totalAnswers = _data["totalAnswers"] !== undefined ? _data["totalAnswers"] : <any>null;
            this.correctAnswers = _data["correctAnswers"] !== undefined ? _data["correctAnswers"] : <any>null;
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
        }
    }

    static fromJS(data: any): InstanceGameStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstanceGameStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["gameInstanceTitle"] = this.gameInstanceTitle !== undefined ? this.gameInstanceTitle : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["profession"] = this.profession !== undefined ? this.profession : <any>null;
        data["startingTime"] = this.startingTime ? this.startingTime.toISOString(true) : <any>null;
        data["playingTime"] = this.playingTime ? this.playingTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["totalAnswers"] = this.totalAnswers !== undefined ? this.totalAnswers : <any>null;
        data["correctAnswers"] = this.correctAnswers !== undefined ? this.correctAnswers : <any>null;
        data["score"] = this.score !== undefined ? this.score : <any>null;
        return data; 
    }
}

export interface IInstanceGameStatisticsDto {
    id: string;
    gameInstanceTitle?: string | null;
    email?: string | null;
    profession?: string | null;
    startingTime?: moment.Moment | null;
    playingTime?: moment.Duration | null;
    totalAnswers: number;
    correctAnswers: number;
    score: number;
}

export class InstancePlayerGameStatisticsDto implements IInstancePlayerGameStatisticsDto {
    id!: string;
    email?: string | null;
    profession?: string | null;
    startingTime?: moment.Moment | null;
    playingTime?: moment.Duration | null;
    totalAnswers!: number;
    correctAnswers!: number;
    score!: number;
    addedCv!: boolean;

    constructor(data?: IInstancePlayerGameStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.profession = _data["profession"] !== undefined ? _data["profession"] : <any>null;
            this.startingTime = _data["startingTime"] ? moment.parseZone(_data["startingTime"].toString()) : <any>null;
            this.playingTime = _data["playingTime"] ? moment.duration(_data["playingTime"].toString()) : <any>null;
            this.totalAnswers = _data["totalAnswers"] !== undefined ? _data["totalAnswers"] : <any>null;
            this.correctAnswers = _data["correctAnswers"] !== undefined ? _data["correctAnswers"] : <any>null;
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
            this.addedCv = _data["addedCv"] !== undefined ? _data["addedCv"] : <any>null;
        }
    }

    static fromJS(data: any): InstancePlayerGameStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstancePlayerGameStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["profession"] = this.profession !== undefined ? this.profession : <any>null;
        data["startingTime"] = this.startingTime ? this.startingTime.toISOString(true) : <any>null;
        data["playingTime"] = this.playingTime ? this.playingTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["totalAnswers"] = this.totalAnswers !== undefined ? this.totalAnswers : <any>null;
        data["correctAnswers"] = this.correctAnswers !== undefined ? this.correctAnswers : <any>null;
        data["score"] = this.score !== undefined ? this.score : <any>null;
        data["addedCv"] = this.addedCv !== undefined ? this.addedCv : <any>null;
        return data; 
    }
}

export interface IInstancePlayerGameStatisticsDto {
    id: string;
    email?: string | null;
    profession?: string | null;
    startingTime?: moment.Moment | null;
    playingTime?: moment.Duration | null;
    totalAnswers: number;
    correctAnswers: number;
    score: number;
    addedCv: boolean;
}

export class InstanceOneGameStatisticDto implements IInstanceOneGameStatisticDto {
    id!: string;
    gameInstanceTitle?: string | null;
    email?: string | null;
    profession?: string | null;
    startingTime?: moment.Moment | null;
    playingTime?: moment.Duration | null;
    totalAnswers!: number;
    correctAnswers!: number;
    score!: number;
    playerInstanceAnswers?: PlayerInstanceAnswersDto[] | null;
    playerInstanceLogs?: PlayerInstanceLogsDto[] | null;

    constructor(data?: IInstanceOneGameStatisticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.gameInstanceTitle = _data["gameInstanceTitle"] !== undefined ? _data["gameInstanceTitle"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.profession = _data["profession"] !== undefined ? _data["profession"] : <any>null;
            this.startingTime = _data["startingTime"] ? moment.parseZone(_data["startingTime"].toString()) : <any>null;
            this.playingTime = _data["playingTime"] ? moment.duration(_data["playingTime"].toString()) : <any>null;
            this.totalAnswers = _data["totalAnswers"] !== undefined ? _data["totalAnswers"] : <any>null;
            this.correctAnswers = _data["correctAnswers"] !== undefined ? _data["correctAnswers"] : <any>null;
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
            if (Array.isArray(_data["playerInstanceAnswers"])) {
                this.playerInstanceAnswers = [] as any;
                for (let item of _data["playerInstanceAnswers"])
                    this.playerInstanceAnswers!.push(PlayerInstanceAnswersDto.fromJS(item));
            }
            if (Array.isArray(_data["playerInstanceLogs"])) {
                this.playerInstanceLogs = [] as any;
                for (let item of _data["playerInstanceLogs"])
                    this.playerInstanceLogs!.push(PlayerInstanceLogsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstanceOneGameStatisticDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstanceOneGameStatisticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["gameInstanceTitle"] = this.gameInstanceTitle !== undefined ? this.gameInstanceTitle : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["profession"] = this.profession !== undefined ? this.profession : <any>null;
        data["startingTime"] = this.startingTime ? this.startingTime.toISOString(true) : <any>null;
        data["playingTime"] = this.playingTime ? this.playingTime.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["totalAnswers"] = this.totalAnswers !== undefined ? this.totalAnswers : <any>null;
        data["correctAnswers"] = this.correctAnswers !== undefined ? this.correctAnswers : <any>null;
        data["score"] = this.score !== undefined ? this.score : <any>null;
        if (Array.isArray(this.playerInstanceAnswers)) {
            data["playerInstanceAnswers"] = [];
            for (let item of this.playerInstanceAnswers)
                data["playerInstanceAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.playerInstanceLogs)) {
            data["playerInstanceLogs"] = [];
            for (let item of this.playerInstanceLogs)
                data["playerInstanceLogs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInstanceOneGameStatisticDto {
    id: string;
    gameInstanceTitle?: string | null;
    email?: string | null;
    profession?: string | null;
    startingTime?: moment.Moment | null;
    playingTime?: moment.Duration | null;
    totalAnswers: number;
    correctAnswers: number;
    score: number;
    playerInstanceAnswers?: PlayerInstanceAnswersDto[] | null;
    playerInstanceLogs?: PlayerInstanceLogsDto[] | null;
}

export class PlayerInstanceAnswersDto implements IPlayerInstanceAnswersDto {
    id!: string;
    playerInstanceId!: string;
    answeredQuestionId!: string;
    answeredQuestion?: string | null;
    answer?: string | null;
    isCorrectAnswer!: boolean;
    dateTimeLog?: moment.Moment | null;

    constructor(data?: IPlayerInstanceAnswersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.playerInstanceId = _data["playerInstanceId"] !== undefined ? _data["playerInstanceId"] : <any>null;
            this.answeredQuestionId = _data["answeredQuestionId"] !== undefined ? _data["answeredQuestionId"] : <any>null;
            this.answeredQuestion = _data["answeredQuestion"] !== undefined ? _data["answeredQuestion"] : <any>null;
            this.answer = _data["answer"] !== undefined ? _data["answer"] : <any>null;
            this.isCorrectAnswer = _data["isCorrectAnswer"] !== undefined ? _data["isCorrectAnswer"] : <any>null;
            this.dateTimeLog = _data["dateTimeLog"] ? moment.parseZone(_data["dateTimeLog"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): PlayerInstanceAnswersDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerInstanceAnswersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["playerInstanceId"] = this.playerInstanceId !== undefined ? this.playerInstanceId : <any>null;
        data["answeredQuestionId"] = this.answeredQuestionId !== undefined ? this.answeredQuestionId : <any>null;
        data["answeredQuestion"] = this.answeredQuestion !== undefined ? this.answeredQuestion : <any>null;
        data["answer"] = this.answer !== undefined ? this.answer : <any>null;
        data["isCorrectAnswer"] = this.isCorrectAnswer !== undefined ? this.isCorrectAnswer : <any>null;
        data["dateTimeLog"] = this.dateTimeLog ? this.dateTimeLog.toISOString(true) : <any>null;
        return data; 
    }
}

export interface IPlayerInstanceAnswersDto {
    id: string;
    playerInstanceId: string;
    answeredQuestionId: string;
    answeredQuestion?: string | null;
    answer?: string | null;
    isCorrectAnswer: boolean;
    dateTimeLog?: moment.Moment | null;
}

export class PlayerInstanceLogsDto implements IPlayerInstanceLogsDto {
    id!: string;
    playerInstanceId!: string;
    logTrigger?: string | null;
    score!: number;
    dateTimeLog?: moment.Moment | null;

    constructor(data?: IPlayerInstanceLogsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.playerInstanceId = _data["playerInstanceId"] !== undefined ? _data["playerInstanceId"] : <any>null;
            this.logTrigger = _data["logTrigger"] !== undefined ? _data["logTrigger"] : <any>null;
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
            this.dateTimeLog = _data["dateTimeLog"] ? moment.parseZone(_data["dateTimeLog"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): PlayerInstanceLogsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerInstanceLogsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["playerInstanceId"] = this.playerInstanceId !== undefined ? this.playerInstanceId : <any>null;
        data["logTrigger"] = this.logTrigger !== undefined ? this.logTrigger : <any>null;
        data["score"] = this.score !== undefined ? this.score : <any>null;
        data["dateTimeLog"] = this.dateTimeLog ? this.dateTimeLog.toISOString(true) : <any>null;
        return data; 
    }
}

export interface IPlayerInstanceLogsDto {
    id: string;
    playerInstanceId: string;
    logTrigger?: string | null;
    score: number;
    dateTimeLog?: moment.Moment | null;
}

export class InstancePlayerStatisticsDto implements IInstancePlayerStatisticsDto {
    email?: string | null;
    profession?: string | null;
    playedProfession?: string[] | null;
    startedGames!: number;
    finishedGames!: number;
    averageTimeForGame!: moment.Duration;
    totalTimeForGames!: moment.Duration;
    percentOfGoodAnswers?: string | null;
    addedCV!: boolean;

    constructor(data?: IInstancePlayerStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.profession = _data["profession"] !== undefined ? _data["profession"] : <any>null;
            if (Array.isArray(_data["playedProfession"])) {
                this.playedProfession = [] as any;
                for (let item of _data["playedProfession"])
                    this.playedProfession!.push(item);
            }
            this.startedGames = _data["startedGames"] !== undefined ? _data["startedGames"] : <any>null;
            this.finishedGames = _data["finishedGames"] !== undefined ? _data["finishedGames"] : <any>null;
            this.averageTimeForGame = _data["averageTimeForGame"] ? moment.duration(_data["averageTimeForGame"].toString()) : <any>null;
            this.totalTimeForGames = _data["totalTimeForGames"] ? moment.duration(_data["totalTimeForGames"].toString()) : <any>null;
            this.percentOfGoodAnswers = _data["percentOfGoodAnswers"] !== undefined ? _data["percentOfGoodAnswers"] : <any>null;
            this.addedCV = _data["addedCV"] !== undefined ? _data["addedCV"] : <any>null;
        }
    }

    static fromJS(data: any): InstancePlayerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstancePlayerStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["profession"] = this.profession !== undefined ? this.profession : <any>null;
        if (Array.isArray(this.playedProfession)) {
            data["playedProfession"] = [];
            for (let item of this.playedProfession)
                data["playedProfession"].push(item);
        }
        data["startedGames"] = this.startedGames !== undefined ? this.startedGames : <any>null;
        data["finishedGames"] = this.finishedGames !== undefined ? this.finishedGames : <any>null;
        data["averageTimeForGame"] = this.averageTimeForGame ? this.averageTimeForGame.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["totalTimeForGames"] = this.totalTimeForGames ? this.totalTimeForGames.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["percentOfGoodAnswers"] = this.percentOfGoodAnswers !== undefined ? this.percentOfGoodAnswers : <any>null;
        data["addedCV"] = this.addedCV !== undefined ? this.addedCV : <any>null;
        return data; 
    }
}

export interface IInstancePlayerStatisticsDto {
    email?: string | null;
    profession?: string | null;
    playedProfession?: string[] | null;
    startedGames: number;
    finishedGames: number;
    averageTimeForGame: moment.Duration;
    totalTimeForGames: moment.Duration;
    percentOfGoodAnswers?: string | null;
    addedCV: boolean;
}

export class PlayerProfileDto implements IPlayerProfileDto {
    email?: string | null;
    gameInstanceTitle?: string | null;
    nicknames?: string[] | null;
    professions?: string[] | null;
    rating!: number;
    isFavorite!: boolean;
    notes?: string | null;
    hasCV!: boolean;

    constructor(data?: IPlayerProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.gameInstanceTitle = _data["gameInstanceTitle"] !== undefined ? _data["gameInstanceTitle"] : <any>null;
            if (Array.isArray(_data["nicknames"])) {
                this.nicknames = [] as any;
                for (let item of _data["nicknames"])
                    this.nicknames!.push(item);
            }
            if (Array.isArray(_data["professions"])) {
                this.professions = [] as any;
                for (let item of _data["professions"])
                    this.professions!.push(item);
            }
            this.rating = _data["rating"] !== undefined ? _data["rating"] : <any>null;
            this.isFavorite = _data["isFavorite"] !== undefined ? _data["isFavorite"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.hasCV = _data["hasCV"] !== undefined ? _data["hasCV"] : <any>null;
        }
    }

    static fromJS(data: any): PlayerProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["gameInstanceTitle"] = this.gameInstanceTitle !== undefined ? this.gameInstanceTitle : <any>null;
        if (Array.isArray(this.nicknames)) {
            data["nicknames"] = [];
            for (let item of this.nicknames)
                data["nicknames"].push(item);
        }
        if (Array.isArray(this.professions)) {
            data["professions"] = [];
            for (let item of this.professions)
                data["professions"].push(item);
        }
        data["rating"] = this.rating !== undefined ? this.rating : <any>null;
        data["isFavorite"] = this.isFavorite !== undefined ? this.isFavorite : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["hasCV"] = this.hasCV !== undefined ? this.hasCV : <any>null;
        return data; 
    }
}

export interface IPlayerProfileDto {
    email?: string | null;
    gameInstanceTitle?: string | null;
    nicknames?: string[] | null;
    professions?: string[] | null;
    rating: number;
    isFavorite: boolean;
    notes?: string | null;
    hasCV: boolean;
}

export class PlayerProfileUpdateInputModel implements IPlayerProfileUpdateInputModel {
    gameInstanceId!: string;
    email!: string;
    rating!: number;
    isFavorite!: boolean;
    notes?: string | null;

    constructor(data?: IPlayerProfileUpdateInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameInstanceId = _data["gameInstanceId"] !== undefined ? _data["gameInstanceId"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : <any>null;
            this.isFavorite = _data["isFavorite"] !== undefined ? _data["isFavorite"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): PlayerProfileUpdateInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerProfileUpdateInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameInstanceId"] = this.gameInstanceId !== undefined ? this.gameInstanceId : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["rating"] = this.rating !== undefined ? this.rating : <any>null;
        data["isFavorite"] = this.isFavorite !== undefined ? this.isFavorite : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data; 
    }
}

export interface IPlayerProfileUpdateInputModel {
    gameInstanceId: string;
    email: string;
    rating: number;
    isFavorite: boolean;
    notes?: string | null;
}

export class AdminUserListItemDto implements IAdminUserListItemDto {
    id!: string;
    email?: string | null;
    isAdmin!: boolean;
    active!: boolean;
    isDeleted!: boolean;
    createdDate!: moment.Moment;
    buyerIdentifier?: string | null;

    constructor(data?: IAdminUserListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.isAdmin = _data["isAdmin"] !== undefined ? _data["isAdmin"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.createdDate = _data["createdDate"] ? moment.parseZone(_data["createdDate"].toString()) : <any>null;
            this.buyerIdentifier = _data["buyerIdentifier"] !== undefined ? _data["buyerIdentifier"] : <any>null;
        }
    }

    static fromJS(data: any): AdminUserListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString(true) : <any>null;
        data["buyerIdentifier"] = this.buyerIdentifier !== undefined ? this.buyerIdentifier : <any>null;
        return data; 
    }
}

export interface IAdminUserListItemDto {
    id: string;
    email?: string | null;
    isAdmin: boolean;
    active: boolean;
    isDeleted: boolean;
    createdDate: moment.Moment;
    buyerIdentifier?: string | null;
}

export class AdminUserUpdateInputModel implements IAdminUserUpdateInputModel {
    id!: string;
    email?: string | null;
    isAdmin!: boolean;
    active!: boolean;

    constructor(data?: IAdminUserUpdateInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.isAdmin = _data["isAdmin"] !== undefined ? _data["isAdmin"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
        }
    }

    static fromJS(data: any): AdminUserUpdateInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserUpdateInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        return data; 
    }
}

export interface IAdminUserUpdateInputModel {
    id: string;
    email?: string | null;
    isAdmin: boolean;
    active: boolean;
}

export class AdminUserDeleteUserInputModel implements IAdminUserDeleteUserInputModel {
    id!: string;

    constructor(data?: IAdminUserDeleteUserInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AdminUserDeleteUserInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDeleteUserInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data; 
    }
}

export interface IAdminUserDeleteUserInputModel {
    id: string;
}

export class AdminUserDataDto implements IAdminUserDataDto {
    id!: string;
    email?: string | null;
    active!: boolean;
    companyName?: string | null;
    vatNumber?: string | null;
    createdDate!: moment.Moment;
    lastLoginDate?: moment.Moment | null;
    buyerIdentifier?: string | null;
    address?: Address | null;

    constructor(data?: IAdminUserDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.vatNumber = _data["vatNumber"] !== undefined ? _data["vatNumber"] : <any>null;
            this.createdDate = _data["createdDate"] ? moment.parseZone(_data["createdDate"].toString()) : <any>null;
            this.lastLoginDate = _data["lastLoginDate"] ? moment.parseZone(_data["lastLoginDate"].toString()) : <any>null;
            this.buyerIdentifier = _data["buyerIdentifier"] !== undefined ? _data["buyerIdentifier"] : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>null;
        }
    }

    static fromJS(data: any): AdminUserDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["vatNumber"] = this.vatNumber !== undefined ? this.vatNumber : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString(true) : <any>null;
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toISOString(true) : <any>null;
        data["buyerIdentifier"] = this.buyerIdentifier !== undefined ? this.buyerIdentifier : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        return data; 
    }
}

export interface IAdminUserDataDto {
    id: string;
    email?: string | null;
    active: boolean;
    companyName?: string | null;
    vatNumber?: string | null;
    createdDate: moment.Moment;
    lastLoginDate?: moment.Moment | null;
    buyerIdentifier?: string | null;
    address?: Address | null;
}

export class GameInstanceAdminDataDto implements IGameInstanceAdminDataDto {
    id!: string;
    title?: string | null;
    userId!: string;
    url?: string | null;
    gameTemplate?: GameTemplateAdminDataDto | null;
    isPublic!: boolean;
    isDeleted!: boolean;
    validUntil?: moment.Moment | null;
    playableFrom?: moment.Moment | null;
    playableTo?: moment.Moment | null;
    assignedProfessions?: string[] | null;
    settings?: string | null;
    lastPaymentBaseData?: PaymentBaseData | null;
    playerInstancesAmmount!: number;
    purchasesAmmount!: number;
    professionsAmmount!: number;

    constructor(data?: IGameInstanceAdminDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.gameTemplate = _data["gameTemplate"] ? GameTemplateAdminDataDto.fromJS(_data["gameTemplate"]) : <any>null;
            this.isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.validUntil = _data["validUntil"] ? moment.parseZone(_data["validUntil"].toString()) : <any>null;
            this.playableFrom = _data["playableFrom"] ? moment.parseZone(_data["playableFrom"].toString()) : <any>null;
            this.playableTo = _data["playableTo"] ? moment.parseZone(_data["playableTo"].toString()) : <any>null;
            if (Array.isArray(_data["assignedProfessions"])) {
                this.assignedProfessions = [] as any;
                for (let item of _data["assignedProfessions"])
                    this.assignedProfessions!.push(item);
            }
            this.settings = _data["settings"] !== undefined ? _data["settings"] : <any>null;
            this.lastPaymentBaseData = _data["lastPaymentBaseData"] ? PaymentBaseData.fromJS(_data["lastPaymentBaseData"]) : <any>null;
            this.playerInstancesAmmount = _data["playerInstancesAmmount"] !== undefined ? _data["playerInstancesAmmount"] : <any>null;
            this.purchasesAmmount = _data["purchasesAmmount"] !== undefined ? _data["purchasesAmmount"] : <any>null;
            this.professionsAmmount = _data["professionsAmmount"] !== undefined ? _data["professionsAmmount"] : <any>null;
        }
    }

    static fromJS(data: any): GameInstanceAdminDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameInstanceAdminDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["gameTemplate"] = this.gameTemplate ? this.gameTemplate.toJSON() : <any>null;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString(true) : <any>null;
        data["playableFrom"] = this.playableFrom ? this.playableFrom.toISOString(true) : <any>null;
        data["playableTo"] = this.playableTo ? this.playableTo.toISOString(true) : <any>null;
        if (Array.isArray(this.assignedProfessions)) {
            data["assignedProfessions"] = [];
            for (let item of this.assignedProfessions)
                data["assignedProfessions"].push(item);
        }
        data["settings"] = this.settings !== undefined ? this.settings : <any>null;
        data["lastPaymentBaseData"] = this.lastPaymentBaseData ? this.lastPaymentBaseData.toJSON() : <any>null;
        data["playerInstancesAmmount"] = this.playerInstancesAmmount !== undefined ? this.playerInstancesAmmount : <any>null;
        data["purchasesAmmount"] = this.purchasesAmmount !== undefined ? this.purchasesAmmount : <any>null;
        data["professionsAmmount"] = this.professionsAmmount !== undefined ? this.professionsAmmount : <any>null;
        return data; 
    }
}

export interface IGameInstanceAdminDataDto {
    id: string;
    title?: string | null;
    userId: string;
    url?: string | null;
    gameTemplate?: GameTemplateAdminDataDto | null;
    isPublic: boolean;
    isDeleted: boolean;
    validUntil?: moment.Moment | null;
    playableFrom?: moment.Moment | null;
    playableTo?: moment.Moment | null;
    assignedProfessions?: string[] | null;
    settings?: string | null;
    lastPaymentBaseData?: PaymentBaseData | null;
    playerInstancesAmmount: number;
    purchasesAmmount: number;
    professionsAmmount: number;
}

export class GameTemplateAdminDataDto implements IGameTemplateAdminDataDto {
    id!: string;
    title?: string | null;
    type!: GameType;

    constructor(data?: IGameTemplateAdminDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): GameTemplateAdminDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameTemplateAdminDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data; 
    }
}

export interface IGameTemplateAdminDataDto {
    id: string;
    title?: string | null;
    type: GameType;
}

export class ProfessionAdminDataDto implements IProfessionAdminDataDto {
    id!: string;
    userId?: string | null;
    title?: string | null;
    displayTitle?: string | null;
    isGlobal!: boolean;
    isDeleted!: boolean;
    questionsCount!: number;
    playerInstancesCount!: number;

    constructor(data?: IProfessionAdminDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.displayTitle = _data["displayTitle"] !== undefined ? _data["displayTitle"] : <any>null;
            this.isGlobal = _data["isGlobal"] !== undefined ? _data["isGlobal"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.questionsCount = _data["questionsCount"] !== undefined ? _data["questionsCount"] : <any>null;
            this.playerInstancesCount = _data["playerInstancesCount"] !== undefined ? _data["playerInstancesCount"] : <any>null;
        }
    }

    static fromJS(data: any): ProfessionAdminDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionAdminDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["displayTitle"] = this.displayTitle !== undefined ? this.displayTitle : <any>null;
        data["isGlobal"] = this.isGlobal !== undefined ? this.isGlobal : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["questionsCount"] = this.questionsCount !== undefined ? this.questionsCount : <any>null;
        data["playerInstancesCount"] = this.playerInstancesCount !== undefined ? this.playerInstancesCount : <any>null;
        return data; 
    }
}

export interface IProfessionAdminDataDto {
    id: string;
    userId?: string | null;
    title?: string | null;
    displayTitle?: string | null;
    isGlobal: boolean;
    isDeleted: boolean;
    questionsCount: number;
    playerInstancesCount: number;
}

export class AuthenticateResponse implements IAuthenticateResponse {
    token?: string | null;
    user?: UserDto | null;

    constructor(data?: IAuthenticateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): AuthenticateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data; 
    }
}

export interface IAuthenticateResponse {
    token?: string | null;
    user?: UserDto | null;
}

export class UserDto implements IUserDto {
    id!: string;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    isAdmin!: boolean;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.isAdmin = _data["isAdmin"] !== undefined ? _data["isAdmin"] : <any>null;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : <any>null;
        return data; 
    }
}

export interface IUserDto {
    id: string;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    isAdmin: boolean;
}

export class AuthenticateRequest implements IAuthenticateRequest {
    email!: string;
    password!: string;

    constructor(data?: IAuthenticateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): AuthenticateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data; 
    }
}

export interface IAuthenticateRequest {
    email: string;
    password: string;
}

export class UserRegisterInputModel implements IUserRegisterInputModel {
    email!: string;
    password!: string;

    constructor(data?: IUserRegisterInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): UserRegisterInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserRegisterInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data; 
    }
}

export interface IUserRegisterInputModel {
    email: string;
    password: string;
}

export class ForgotPasswordConfirmationInputModel implements IForgotPasswordConfirmationInputModel {
    code!: string;
    newPassword!: string;

    constructor(data?: IForgotPasswordConfirmationInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : <any>null;
        }
    }

    static fromJS(data: any): ForgotPasswordConfirmationInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordConfirmationInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : <any>null;
        return data; 
    }
}

export interface IForgotPasswordConfirmationInputModel {
    code: string;
    newPassword: string;
}

export class ChangePasswordInputModel implements IChangePasswordInputModel {
    oldPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"] !== undefined ? _data["oldPassword"] : <any>null;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : <any>null;
        }
    }

    static fromJS(data: any): ChangePasswordInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword !== undefined ? this.oldPassword : <any>null;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : <any>null;
        return data; 
    }
}

export interface IChangePasswordInputModel {
    oldPassword: string;
    newPassword: string;
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}